var _a;
import { A as AccountDrawer, S as SearchSpringElement, o as onResizeDebounced, U as UniversalModal, R as RedesignMegaMenu, s as setAndGetSearchspringCookies, r as renderProductCardsFromHandles, C as CartComponent, a as CustomFooter, l as lazyLoadImages, i as initProductCardSwatchListeners, b as applyMoreColorsIndicator, c as createLinkFromTemplate, d as initAddToBag, e as cart, P as ProductConfigurables, p as productQty, f as ProductGallery, g as productSwatches, h as Splide } from "./sticky-header-B-J49vFi.js";
class HeaderHandler {
  constructor() {
    this.accountDrawer = new AccountDrawer();
    this.searchSpring = new SearchSpringElement();
    this.accountLink = document.querySelector(".account-link");
    this.mobileBTN = document.getElementById("mobile__menu-btn");
    this.menudrawer = document.getElementById("mobile__menu-drawer");
    this.closeDrawer = document.getElementById("mobile__menu--close-drawer");
    this.backBtn = document.getElementById("mobile__menu--back-drawer");
    this.desktopMenu = document.querySelector(".nav-desktop");
    this.mobileMenu = document.querySelector(".nav-mobile");
    this.searchModal = document.querySelector(".modal-search");
  }
  init() {
    this.initMegaMenu(".mega-menu");
    this.replicateDesktopMenuToMobile();
    this.subItems = this.mobileMenu.querySelectorAll(".sub-item.has--dropdown");
    this.mobileMegaMenus = this.mobileMenu.querySelectorAll(".mega-menu");
    this.handleMobileDrawerMenu("mobile__menu--close-drawer", "mobile__menu--back-drawer");
    const tabs = this.mobileMenu.querySelectorAll(".menu-item");
    const tabContents = this.mobileMenu.querySelectorAll(".menu-item--content");
    this.handleMobileTabMenu(tabs, tabContents);
    this.openMobileMenu();
    this.closeMobileMenu();
    this.accountDrawer.init();
    this.handleAccountLinkClick();
    this.enableDesktopMegamenu();
    onResizeDebounced(() => {
      this.accountDrawer.init();
      this.toggleMobileDrawer(window.innerWidth <= _JK.helpers.JSbreakpoints.mobile);
    });
  }
  toggleMobileDrawer(isMobile) {
    const drawer = document.getElementById("submenu-mobile__drawer");
    if (drawer) {
      drawer.style.display = isMobile ? "block" : "none";
    }
  }
  /**
   * Enables and initializes the desktop mega menu state based on the current page context.
   *
   * This function highlights the appropriate tab and reveals the corresponding menu content
   * by matching either the current page path (`window.location.pathname`) or the Shopify-specific
   * `SDG.Data.context` value.
   *
   * Key Features:
   * - Finds and highlights the correct `.tab-link` based on pathname (excluding home `/`).
   * - Uses `data-menu-context` attributes to identify and display the matching `.menu-item--content`.
   * - Falls back to showing the first menu and its associated tab if no match is found.
   * - Ensures only the correct menu/tab is visible/active; all others are hidden or reset.
   *
  */
  enableDesktopMegamenu() {
    var _a2;
    if (!this.desktopMenu || typeof ((_a2 = SDG == null ? void 0 : SDG.Data) == null ? void 0 : _a2.context) !== "string") return;
    const context = SDG.Data.context.toLowerCase();
    const currentPath = window.location.pathname;
    let matchedMenu = null;
    let matchedTab = null;
    const allMenuContents = this.desktopMenu.querySelectorAll(".menu-item--content");
    const allTabLinks = this.desktopMenu.querySelectorAll("a.tab-link");
    allTabLinks.forEach((link) => {
      const href = link.getAttribute("href");
      link.classList.remove("active-tab", "before:w-full");
      if (href === currentPath && href !== "/") {
        matchedTab = link;
      }
    });
    if (matchedTab) {
      matchedTab.classList.add("active-tab", "before:w-full");
    }
    allMenuContents.forEach((menu) => {
      var _a3;
      const menuContext = ((_a3 = menu.getAttribute("data-menu-context")) == null ? void 0 : _a3.toLowerCase()) || "";
      if (!matchedTab) {
        const tabItem = menu.previousElementSibling;
        tabItem == null ? void 0 : tabItem.classList.remove("active-tab", "before:w-full");
      }
      if (menuContext && menuContext === context) {
        matchedMenu = menu;
      }
    });
    const menuToShow = matchedMenu || allMenuContents[0];
    const tabToActivate = menuToShow == null ? void 0 : menuToShow.previousElementSibling;
    if (menuToShow) {
      menuToShow.classList.remove("invisible");
      menuToShow.classList.add("visible");
    }
    if (tabToActivate && tabToActivate !== matchedTab && !matchedTab) {
      tabToActivate.classList.add("active-tab", "before:w-full");
    }
  }
  handleAccountLinkClick() {
    var _a2;
    (_a2 = this.accountLink) == null ? void 0 : _a2.addEventListener("click", () => this.accountDrawer.openDrawer());
  }
  initSearchModal(modalSelector, triggerSelector, closeSelector) {
    this.searchModal = new UniversalModal(modalSelector, triggerSelector, closeSelector);
    this.searchSpring.init();
    const displayHeaderStyle = getComputedStyle(document.querySelector(".header_action-items")).display;
    if (displayHeaderStyle == "flex") {
      const pencilBannerHeight = document.querySelector(".redesign-pencil-banner").clientHeight;
      const headerHeight = document.querySelector("header").clientHeight;
      document.querySelector(".modal-search").style.top = pencilBannerHeight + headerHeight;
    }
  }
  initMegaMenu(menuSelector) {
    document.querySelectorAll(menuSelector).forEach((menuElement) => {
      new RedesignMegaMenu(menuElement);
    });
  }
  replicateDesktopMenuToMobile() {
    this.mobileMenu.innerHTML = this.desktopMenu.innerHTML;
    const subItems = this.mobileMenu.querySelectorAll(".sub-item-primary.has--dropdown");
    subItems.forEach((el) => {
      el.className = "has--dropdown sub-item px-20 py-7 text-charcoal-100 redesign-body-3 inline-block";
    });
    const subItems2 = this.mobileMenu.querySelectorAll(".sub-item-primary.has--no--dropdown");
    subItems2.forEach((el) => {
      el.className = "sub-item px-20 py-7 text-charcoal-100 redesign-body-3 inline-block";
    });
    if (window.innerWidth <= _JK.helpers.JSbreakpoints.mobile) {
      const drawerDiv = document.createElement("div");
      drawerDiv.classList.add("submenu-drawer", "translate-x-full", "duration-300", "w-full");
      drawerDiv.setAttribute("id", "submenu-mobile__drawer");
      drawerDiv.style.position = "fixed";
      drawerDiv.style.top = "0";
      drawerDiv.style.left = "0";
      drawerDiv.style.height = "100vh";
      drawerDiv.style.overflow = "hidden";
      drawerDiv.style.backgroundColor = "var(--color-ivory)";
      drawerDiv.style.zIndex = 99;
      drawerDiv.style.textAlign = "center";
      document.body.appendChild(drawerDiv);
    }
  }
  createMenu(label, url, id) {
    const linkWrapper = document.createElement("div");
    linkWrapper.classList.add("flex", "items-center", "sub-item");
    const link = document.createElement("a");
    link.href = url;
    link.title = label;
    link.id = id;
    link.classList.add(
      "redesign-body-3",
      "cursor-pointer",
      "sub-item",
      "has--dropdown",
      "inline-flex",
      "items-center",
      "gap-2",
      "text-ivory",
      "bg-none",
      "pl-0",
      "pr-0",
      "pt-0",
      "pb-7",
      "outline-none",
      "capitalize",
      "transition-all",
      "duration-300",
      "ease-in-out",
      "before:absolute",
      "before:left-0",
      "before:bottom-15",
      "before:h-1",
      "before:w-0",
      "before:bg-charcoal-100",
      "before:transition-all",
      "before:duration-300",
      "hover:before:w-full",
      "h-48",
      "capitalize"
    );
    link.textContent = label;
    linkWrapper.appendChild(link);
    return linkWrapper;
  }
  handleMobileDrawerMenu(closeDrawerSelector, backBtnSelector) {
    const closeDrawer = document.getElementById(closeDrawerSelector);
    const backBtn = document.getElementById(backBtnSelector);
    const submenuDrawer = document.querySelector(".submenu-drawer");
    this.mobileMegaMenus.forEach((megamenu, key) => {
      const activeSubItem = megamenu.querySelector(".sub-item");
      megamenu.querySelector(".grid").classList.add("accordion", "gap-4", "py-24");
      megamenu.setAttribute("data-target", megamenu.getAttribute("id"));
      const activeCloseDrawerBtn = closeDrawer.cloneNode(true);
      const activebackBtn = backBtn.cloneNode(true);
      activebackBtn.setAttribute("id", `${backBtn.getAttribute("id")}-${key}`);
      activeCloseDrawerBtn.setAttribute("id", `${closeDrawer.getAttribute("id")}-${key}`);
      activebackBtn.classList.add("hidden", "absolute", "top-12", "py-18", "left-20", "pr-20");
      activeCloseDrawerBtn.classList.add("hidden", "absolute", "top-12", "py-16", "right-20", "pl-24");
      activeSubItem.parentNode.insertBefore(activebackBtn, activeSubItem);
      activeSubItem.parentNode.insertBefore(activeCloseDrawerBtn, activeSubItem.nextSibling);
      const menuWrappers = megamenu.querySelectorAll(".menu-item--wrapper");
      if (menuWrappers.length > 1) {
        menuWrappers.forEach((menuWrapper) => {
          const subItemWrapper = menuWrapper.querySelector(".menu__sub-item--wrapper");
          const megaMenuHeading = menuWrapper.querySelector("h3");
          if (megaMenuHeading && subItemWrapper) {
            const accordionToggle = document.createElement("button");
            accordionToggle.classList.add(
              "js-acc-btn",
              "accordion-toggle",
              "acc__btn",
              "flex",
              "items-center",
              "justify-between",
              "py-14",
              "w-full",
              "h-[3rem]",
              "border-charcoal-10"
            );
            const titleSpan = document.createElement("span");
            titleSpan.classList.add("acc__title", "redesign-body-5", "text-charcoal-100");
            titleSpan.innerHTML = megaMenuHeading.innerHTML;
            const iconWrapper = document.createElement("span");
            iconWrapper.classList.add("accordion-icons", "cursor-pointer");
            iconWrapper.innerHTML = _JK.icons.plus + _JK.icons.minus;
            accordionToggle.appendChild(titleSpan);
            accordionToggle.appendChild(iconWrapper);
            megaMenuHeading.replaceWith(accordionToggle);
            subItemWrapper.classList.add("js-acc-menu", "acc__menu", "overflow-hidden", "transition-[height]", "duration-300", "ease-[ease-in-out]");
          }
        });
      }
    });
    const backBtnDOM = this.backBtn.parentElement;
    this.subItems.forEach((subItem, key) => {
      subItem.addEventListener("click", (e) => {
        e.preventDefault();
        if (backBtnDOM == null ? void 0 : backBtnDOM.classList.contains("hidden")) {
          backBtnDOM == null ? void 0 : backBtnDOM.classList.remove("hidden");
        }
        const activeMegaMenu = this.mobileMenu.querySelector(`#${e.target.dataset.parent}`);
        activeMegaMenu == null ? void 0 : activeMegaMenu.setAttribute("aria-expanded", true);
        const copyMegaMenu = activeMegaMenu.cloneNode(true);
        const itemContent = copyMegaMenu.querySelector(".menu__item--content");
        itemContent.querySelector(".menu__item--content-container").classList.remove("pt-40");
        itemContent == null ? void 0 : itemContent.removeAttribute("style");
        submenuDrawer.innerHTML = "";
        const mobileDrawerHeight = submenuDrawer.clientHeight;
        submenuDrawer.appendChild(copyMegaMenu);
        submenuDrawer.querySelectorAll(".menu-item--wrapper").forEach((itemWrapper) => {
          itemWrapper.style.textAlign = "left";
        });
        submenuDrawer.querySelector(".menu__item--content").classList.remove("invisible", "opacity-0", "w-0", "border-t", "border-t-[1px]", "border-t-[var(--color-charcoal-10)]");
        const submenuDrawerAccordion = submenuDrawer.querySelector(".accordion");
        submenuDrawerAccordion.classList.remove("px-[1.5rem]");
        submenuDrawerAccordion.setAttribute("id", `${subItem.getAttribute("id")}-${key}`);
        if (submenuDrawerAccordion.style.maxHeight) {
          submenuDrawerAccordion.style.maxHeight = null;
        } else {
          const availableHeight = mobileDrawerHeight - 100;
          submenuDrawerAccordion.style.maxHeight = `${availableHeight}px`;
          submenuDrawerAccordion.style.overflowY = "auto";
        }
        submenuDrawer.querySelector(".sub-item.has--dropdown").classList.remove("text-ivory", "pb-[0.4375rem]");
        submenuDrawer.querySelector(".sub-item.has--dropdown").classList.add("text-charcoal-100");
        submenuDrawer.querySelectorAll(".nav__menu").forEach((navmenu) => {
          navmenu.classList.add("col-span-4");
        });
        submenuDrawer.querySelectorAll(".image-block").forEach((navmenu) => {
          navmenu.classList.add("col-span-2");
        });
        this.handleAccordionMenu("accordion-toggle", "accordion-content", "submenu-mobile__drawer");
        submenuDrawer.classList.remove("translate-x-full");
        submenuDrawer.classList.add("translate-x-0");
        const closeBtnMainDrawer = submenuDrawer.querySelector(".mobile__menu--close-drawer");
        const backBtnMainDrawer = submenuDrawer.querySelector(".mobile__menu--back-drawer");
        backBtnMainDrawer.classList.remove("hidden");
        closeBtnMainDrawer.classList.remove("hidden");
        backBtnMainDrawer.addEventListener("click", () => {
          if (!(backBtnDOM == null ? void 0 : backBtnDOM.classList.contains("hidden"))) {
            backBtnDOM == null ? void 0 : backBtnDOM.classList.add("hidden");
          }
          activeMegaMenu.setAttribute("aria-expanded", false);
          submenuDrawer.innerHTML = "";
          submenuDrawer.classList.remove("translate-x-0");
          submenuDrawer.classList.add("translate-x-full");
          this.menudrawer.classList.add("translate-x-0");
          this.menudrawer.classList.remove("-translate-x-full");
          document.body.classList.remove("fixed");
          document.body.classList.add("ui-active");
        });
        closeBtnMainDrawer.addEventListener("click", () => {
          activeMegaMenu.setAttribute("aria-expanded", false);
          submenuDrawer.innerHTML = "";
          submenuDrawer.classList.remove("translate-x-0");
          submenuDrawer.classList.add("translate-x-full");
          this.menudrawer.classList.remove("translate-x-0");
          this.menudrawer.classList.add("-translate-x-full");
          backBtnMainDrawer.classList.add("hidden");
          document.body.classList.remove("fixed", "ui-active", "overflow-hidden");
        });
      });
    });
  }
  handleAccordionMenu(accordionSelectors, accordionContents, accordionId) {
    const accordionMegaMenu = SDG.accordion({
      dom: {
        btn: accordionSelectors,
        id: accordionId,
        menu: accordionContents
      },
      open_option: 0,
      type: "toggle"
    });
    accordionMegaMenu.init();
  }
  /**
   * Handles the tab switching behavior for the mobile mega menu.
   *
   * This function supports matching the current tab based on the page path or Shopify context (`SDG.Data.context`),
   * adds/removes active tab styles, and displays corresponding tab content panels.
   * 
   * Key Features:
   * - Highlights the matching tab based on `window.location.pathname`.
   * - Matches and displays the appropriate tab content using `data-menu-context`.
   * - Registers `click`, `touchstart`, and `touchend` events for interaction support.
   * - Dynamically updates the `.account__links-mobile` position based on the height of the active tab content.
   *
   * @param {NodeList} tabSelector - A list of tab elements (e.g., `.menu-item`)
   * @param {NodeList} tabContentSelector - A list of corresponding tab content panels (e.g., `.menu-item--content`)
   */
  handleMobileTabMenu(tabSelector, tabContentSelector) {
    var _a2, _b;
    const tabs = tabSelector;
    const tabContents = tabContentSelector;
    const context = ((_b = (_a2 = SDG == null ? void 0 : SDG.Data) == null ? void 0 : _a2.context) == null ? void 0 : _b.toLowerCase()) || "";
    const currentPath = window.location.pathname;
    let matchedTab = null;
    tabs.forEach((tab) => {
      const tabLink = tab;
      if (tab.pathname && currentPath === tab.pathname) {
        tabs.forEach((tab2) => tab2.classList.remove("active-tab"));
        tabContents.forEach((content) => content.classList.remove("active-content", "hidden"));
        tabLink.classList.add("active-tab");
        tabLink.nextElementSibling.classList.add("active-content");
        matchedTab = true;
      }
    });
    tabs.forEach((tab, key) => {
      var _a3;
      const tabContent = tabContents[key];
      tab.setAttribute("data-tab", tab.getAttribute("id"));
      tabContent.setAttribute("id", tab.getAttribute("id"));
      tab.removeAttribute("id");
      const tabContext = (_a3 = tabContent.getAttribute("data-menu-context")) == null ? void 0 : _a3.toLowerCase();
      if (tabContext === context) {
        if (matchedTab != true) {
          tab.classList.add("active-tab");
        }
        tabContent.classList.add("active-content");
        tabContent.classList.remove("invisible");
        tabContent.classList.add("visible");
      }
      ["touchstart", "touchend", "click"].forEach((eventType) => {
        tab.addEventListener(eventType, (e) => {
          if (e.currentTarget.classList.contains("has--sub-item")) {
            if (e.cancelable) {
              e.preventDefault();
            }
            tabContents.forEach((content, k) => {
              tabs[k].classList.remove("active-tab");
              if (content.classList.contains("active-content")) {
                content.removeAttribute("style");
                content.classList.remove("active-content");
              }
              content.classList.add("hidden");
            });
            tab.classList.add("active-tab");
            const targetTab = tab.getAttribute("data-tab");
            const currentTab = document.getElementById(targetTab);
            currentTab.classList.remove("hidden", "invisible");
            currentTab.classList.add("active-content");
            const mainMenuHeight = currentTab.offsetHeight + 160;
            currentTab.style.height = `${currentTab.offsetHeight - 60}px`;
            if (mainMenuHeight > window.innerHeight) {
              currentTab.classList.add("overflow-y-auto");
            } else {
              currentTab.classList.remove("overflow-y-auto");
            }
          }
        });
      });
    });
  }
  openMobileMenu() {
    this.mobileBTN.addEventListener("click", () => {
      var _a2;
      (_a2 = this.menudrawer.querySelector(".mobile__menu--back-drawer")) == null ? void 0 : _a2.classList.add("hidden");
      this.searchModal.close();
      this.menudrawer.classList.remove("-translate-x-full");
      this.menudrawer.classList.add("translate-x-0");
      document.body.classList.add("fixed", "overflow-hidden", "ui-active");
      this.mobileBTN.setAttribute("aria-expanded", "true");
      const activeTab = this.menudrawer.querySelector(".menu-item--content.active-content");
      const accountLinks = this.menudrawer.querySelector(".account__links-mobile");
      this.menudrawer.querySelectorAll(".menu-item--content").forEach((menuItem) => {
        const existingAccountMenu = menuItem.querySelector(".account__links-mobile");
        if (existingAccountMenu) {
          menuItem.removeChild(existingAccountMenu);
        }
        const accountMenu = accountLinks.cloneNode(true);
        accountMenu.classList.remove("hidden", "absolute");
        if (!menuItem.querySelector(".account__links-mobile")) {
          accountMenu.classList.add("pt-20");
          menuItem.appendChild(accountMenu);
        }
      });
      activeTab.removeAttribute("style");
      const activeTabHeight = (activeTab == null ? void 0 : activeTab.offsetHeight) || 0;
      const spacing = 100;
      const totalHeight = activeTabHeight + spacing;
      activeTab.style.height = `${activeTabHeight - 60}px`;
      if (accountLinks) {
        accountLinks.classList.add("hidden");
      }
      if (totalHeight > window.innerHeight) {
        activeTab.classList.add("overflow-y-auto");
      } else {
        activeTab.classList.remove("overflow-y-auto");
      }
      this.menudrawer.querySelectorAll(".menu__item--content").forEach((menuItem) => {
        menuItem.style.display = "none";
      });
    });
  }
  closeMobileMenu() {
    this.closeDrawer.addEventListener("click", () => {
      this.menudrawer.classList.remove("translate-x-0");
      this.menudrawer.classList.add("-translate-x-full");
      document.body.classList.remove("fixed", "overflow-hidden", "ui-active");
      this.mobileBTN.setAttribute("aria-expanded", "false");
      const drawer = document.querySelector("#mobile__menu-drawer");
      const wrapper = document.querySelector(".mobile__menu-drawer--wrapper");
      drawer == null ? void 0 : drawer.classList.remove("overflow-y-auto");
      if (wrapper) wrapper.style.height = "";
    });
  }
}
function updateTabTitle() {
  var _a2, _b, _c, _d, _e;
  let pos = 2;
  const newTitle = (_c = (_b = (_a2 = window == null ? void 0 : window.SDG) == null ? void 0 : _a2.Site) == null ? void 0 : _b.update_tab_title) == null ? void 0 : _c.message;
  const { scroll } = ((_e = (_d = window == null ? void 0 : window.SDG) == null ? void 0 : _d.Site) == null ? void 0 : _e.update_tab_title) || {};
  const currentTitle = document.title;
  function scrollTabTitle() {
    if (scrollTabTitle.timer) clearInterval(scrollTabTitle.timer);
    scrollTabTitle.timer = setInterval(() => {
      document.title = newTitle.substring(pos, newTitle.length) + newTitle.substring(0, pos);
      pos += 1;
      if (pos > newTitle.length) {
        pos = 0;
      }
    }, 200);
  }
  document.addEventListener("visibilitychange", () => {
    if (document.visibilityState === "hidden") {
      if (scroll) {
        scrollTabTitle();
      } else {
        document.title = newTitle;
      }
    } else {
      clearInterval(scrollTabTitle.timer);
      document.title = currentTitle;
    }
  });
}
_.debounce = function(func, threshold, execAsap) {
  let timeout;
  return function debounced() {
    let obj = this, args = arguments;
    function delayed() {
      if (!execAsap)
        func.apply(obj, args);
      timeout = null;
    }
    if (timeout)
      clearTimeout(timeout);
    else if (execAsap)
      func.apply(obj, args);
    timeout = setTimeout(delayed, threshold || 100);
  };
};
const debounce = _.debounce;
function trapFocus(container) {
  const focusableSelectors = [
    "a[href]",
    "area[href]",
    'input:not([disabled]):not([type="hidden"])',
    "select:not([disabled])",
    "textarea:not([disabled])",
    "button:not([disabled])",
    "iframe",
    "object",
    "embed",
    "[contenteditable]",
    '[tabindex]:not([tabindex="-1"])'
  ];
  if (typeof container._removeFocusTrap === "function") {
    container._removeFocusTrap();
  }
  function getFocusableElements() {
    return Array.from(container.querySelectorAll(focusableSelectors.join(","))).filter((el) => el.offsetParent !== null);
  }
  function handleKeydown(e) {
    if (e.key !== "Tab") return;
    const focusableEls = getFocusableElements();
    const firstEl = focusableEls[0];
    const lastEl = focusableEls[focusableEls.length - 1];
    if (focusableEls.length === 0) return;
    if (e.shiftKey) {
      if (document.activeElement === firstEl) {
        e.preventDefault();
        lastEl.focus();
      }
    } else {
      if (document.activeElement === lastEl) {
        e.preventDefault();
        firstEl.focus();
      }
    }
  }
  function handleEscape(e) {
    if (e.key === "Escape") {
      if (typeof container._onEscape === "function") {
        container._onEscape();
      }
    }
  }
  document.addEventListener("keydown", handleKeydown);
  document.addEventListener("keydown", handleEscape);
  container._removeFocusTrap = () => {
    document.removeEventListener("keydown", handleKeydown);
    document.removeEventListener("keydown", handleEscape);
  };
  const first = getFocusableElements()[0];
  if (first) first.focus();
}
function intelliSuggest(ssData) {
  if (!ssData) return;
  window._JK = window._JK || {};
  window._JK.intelliSuggest = window._JK.intelliSuggest || {};
  ssData.forEach((product) => {
    window._JK.intelliSuggest[product.handle] = {
      intellisuggestData: product.intellisuggestData,
      intellisuggestSignature: product.intellisuggestSignature
    };
  });
}
class Collection {
  //------------------------------------------------------------------------------------------------
  constructor() {
    this.$collectionContainer = document.getElementById("js-collection-container");
    this.$productGrid = document.getElementById("js-collection-product-grid");
    this.$loadMoreButtonWrapper = document.getElementById("js-show-more-trigger-wrapper");
    this.$loadMoreButton = document.getElementById("js-show-more-trigger");
    this.$totalProductCount = document.getElementById("js-total-product-count");
    this.$currentProductCount = document.getElementById("js-current-product-count");
    this.$filtersDrawerWrapper = document.getElementById("js-collection-filters-drawer-wrapper");
    this.$filtersBackdrop = document.getElementById("js-collection-filters-backdrop");
    this.$filtersDrawer = document.getElementById("js-collection-filters-drawer");
    this.$filtersContent = document.getElementById("js-collection-filters-content");
    this.$filtersButton = document.getElementById("js-filters-trigger");
    this.$filtersCloseButton = document.getElementById("js-close-filters-button");
    this.$filtersApplyButton = document.getElementById("js-apply-filters-button");
    this.$filtersClearButtonWrapper = document.getElementById("js-clear-filters-button-wrapper");
    this.$filtersClearButtons = document.querySelectorAll(".js-clear-filters-button");
    this.$filterCountTotals = document.querySelectorAll(".js-filter-count-total");
    this.$filterSummaryWrapper = document.getElementById("js-filter-summary-wrapper");
    this.$filterSummary = document.getElementById("js-filter-summary");
    this.activeFilterGroupIndex = null;
    this.$sortModalWrapper = document.getElementById("js-collection-sort-modal-wrapper");
    this.$sortModal = document.getElementById("js-collection-sort-modal");
    this.$sortContent = document.getElementById("js-collection-sort-content");
    this.$sortButton = document.getElementById("js-collection-sort-trigger");
    this.$sortLabel = document.getElementById("js-collection-sort-label");
    this.$sortAscIcon = document.getElementById("js-icon-sort-asc");
    this.$sortDescIcon = document.getElementById("js-icon-sort-desc");
    this.ssId = SDG.Data.ssId;
    this.resultsPerPage = _JK.collections.resultsPerPage || 12;
    this.pageInfo = 1;
    this.collectionId = this.$productGrid ? this.$productGrid.dataset.collectionId : null;
    this.collectionHandle = this.$productGrid ? this.$productGrid.dataset.collectionHandle : null;
    this.url = window.location.href;
    this.urlParams = new URLSearchParams(window.location.search);
    this.activeFilters = this.getFiltersFromUrl();
    const [sortData] = this.getSortFromUrl();
    this.sort = (sortData == null ? void 0 : sortData.key) || null;
    this.sortOrder = (sortData == null ? void 0 : sortData.value) || "asc";
    this.ssUrl = this.formatSearchSpringUrl();
  }
  //------------------------------------------------------------------------------------------------
  async init() {
    const ssData = await this.fetchSearchSpringData();
    this.initPage(ssData, "replace");
    this.initSort();
    this.addEventListeners();
  }
  //------------------------------------------------------------------------------------------------
  initPage(ssData, action = "replace") {
    if (!ssData) {
      console.warn("No ssData found for this collection.");
      this.$productGrid.innerHTML = '<p class="text-red-100 redesign-body-3">ERROR: No data found for this collection.</p>';
      return;
    }
    this.productsData = ssData.results;
    this.filtersData = ssData.facets || [];
    this.sortData = ssData.sorting || [];
    this.filterSummaryData = ssData.filterSummary || {};
    this.paginationData = ssData.pagination || {};
    if (action === "replace") {
      this.clearResults();
    }
    this.displayProducts(action);
    if (!this.filtersInitialized) {
      this.addActiveFilters();
      this.initFiltersAccordion();
      this.filtersInitialized = true;
      this.updateCounts();
    } else {
      this.filtersData = ssData.facets;
      this.updateCounts();
      this.updateFilterStates();
    }
    this.displayFilterSummary();
  }
  // **************************************************************************
  // EVENTS
  // **************************************************************************
  //------------------------------------------------------------------------------------------------
  addEventListeners() {
    [
      this.$filtersButton,
      this.$filtersBackdrop,
      this.$filtersCloseButton,
      this.$filtersApplyButton
    ].forEach((el) => {
      el.addEventListener("click", (e) => {
        e.preventDefault();
        e.stopPropagation();
        this.toggleFiltersDrawer();
      });
    });
    this.$filtersClearButtons.forEach((button) => {
      button.addEventListener("click", (e) => {
        e.preventDefault();
        e.stopPropagation();
        this.clearFilters();
        this.handleFilterChange("", "");
      });
    });
    this.addFilterOptionListeners();
    this.$sortButton.addEventListener("click", (e) => {
      e.preventDefault();
      e.stopPropagation();
      this.toggleSortModal();
    });
    const sortOptions = this.$sortContent.querySelectorAll(".js-sort-option");
    sortOptions.forEach((option) => {
      option.addEventListener("change", (e) => {
        var _a2, _b, _c;
        e.preventDefault();
        e.stopPropagation();
        this.sort = ((_a2 = e.target.dataset) == null ? void 0 : _a2.sort) || null;
        this.sortLabel = ((_b = e.target.dataset) == null ? void 0 : _b.sortLabel) || null;
        this.sortOrder = ((_c = e.target.dataset) == null ? void 0 : _c.sortOrder) || null;
        this.handleSortChange();
      });
    });
    this.$loadMoreButton.addEventListener("click", (e) => {
      e.preventDefault();
      e.stopPropagation();
      debounce(this.showMoreProducts(), 300);
    });
  }
  //------------------------------------------------------------------------------------------------
  addFilterOptionListeners() {
    this.$filtersContent.addEventListener("change", (e) => {
      if (e.target.matches('.js-filter-option[type="checkbox"]') && e.target instanceof HTMLInputElement) {
        const input = e.target;
        const filterKey = input.dataset.filter;
        const filterValue = input.dataset.value;
        this.handleFilterChange(filterKey, filterValue);
      }
    });
  }
  // **************************************************************************
  // SEARCHSPRING METHODS
  // **************************************************************************
  //------------------------------------------------------------------------------------------------
  async fetchSearchSpringData() {
    try {
      const response = await fetch(this.ssUrl);
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      const data = await response.json();
      return data;
    } catch (error) {
      console.error("Error fetching SS Data:", error);
      console.error(`  - ERR ssURL: ${this.ssUrl}`);
      return null;
    }
  }
  //------------------------------------------------------------------------------------------------
  formatSearchSpringUrl() {
    const {
      sessionCookie,
      userId,
      pageLoadId
    } = setAndGetSearchspringCookies();
    const ssBaseUrl = `https://${this.ssId}.a.searchspring.io/api/search/search.json`;
    const ssParams = new URLSearchParams({
      domain: `/collections/${this.collectionHandle}`,
      resultsFormat: "native",
      siteId: this.ssId,
      sessionId: sessionCookie,
      userId,
      pageLoadId,
      resultsPerPage: this.resultsPerPage,
      page: this.pageInfo,
      "bgfilter.collection_id": this.collectionId
    });
    if (this.activeFilters) {
      this.activeFilters.forEach((filter) => {
        ssParams.append(filter.key, filter.value);
      });
    }
    if (this.sort && this.sortOrder) {
      ssParams.append(`${this.sort}`, this.sortOrder);
    }
    const ssUrl = `${ssBaseUrl}?${ssParams.toString()}`;
    return ssUrl;
  }
  //------------------------------------------------------------------------------------------------
  displayProducts(action) {
    if (!this.productsData || this.productsData.length === 0) {
      this.$productGrid.innerHTML = '<p class="redesign-body-4 text-charcoal-100">No products available in this collection.</p>';
      return;
    }
    intelliSuggest(this.productsData);
    const handlesToRender = this.productsData.map((product) => product.handle);
    renderProductCardsFromHandles(
      handlesToRender,
      this.$productGrid,
      {
        view: "get-product-card",
        cardClasses: ["basis-[calc(50%-4px)]", "lg:basis-1/4"],
        action
      }
    );
    if (this.paginationData.currentPage < this.paginationData.totalPages) {
      this.$loadMoreButtonWrapper.classList.remove("hidden");
    } else {
      this.$loadMoreButtonWrapper.classList.add("hidden");
    }
  }
  //------------------------------------------------------------------------------------------------
  showMoreProducts() {
    this.pageInfo += 1;
    this.ssUrl = this.formatSearchSpringUrl();
    this.fetchSearchSpringData().then((ssData) => {
      this.initPage(ssData, "append");
    }).catch((error) => {
      console.error("Error fetching more products:", error);
      this.$loadMoreButtonWrapper.classList.add("hidden");
    });
  }
  //------------------------------------------------------------------------------------------------
  clearResults() {
    this.$productGrid.innerHTML = "";
  }
  //------------------------------------------------------------------------------------------------
  updateCounts() {
    this.$currentProductCount.innerHTML = this.paginationData.end;
    this.$totalProductCount.innerHTML = this.paginationData.totalResults;
    if (this.activeFilters) {
      this.$filterCountTotals.forEach((counter) => {
        counter.innerHTML = `(${this.activeFilters.length})`;
        if (this.activeFilters.length > 0) {
          counter.classList.remove("hidden");
        } else {
          counter.classList.add("hidden");
        }
      });
    }
    for (var filter in this.filterCounts) {
      const count = this.filterCounts[filter] === 0 ? "" : `(${this.filterCounts[filter]})`;
      const counterID = `filter_count_${filter}`;
      const $counter = document.getElementById(counterID);
      $counter.innerHTML = count;
    }
  }
  // **************************************************************************
  // SORT METHODS 
  // **************************************************************************
  //------------------------------------------------------------------------------------------------
  initSort() {
    this.$sortContent.innerHTML = "";
    this.sortData.options.forEach((sort) => {
      const sortElement = document.createElement("div");
      sortElement.classList.add("redesign-body-7", "text-charcoal-100", "py-8");
      let checked = "";
      if (sort.active) {
        sortElement.classList.add("active");
        checked = "checked";
        this.$sortLabel.innerHTML = sort.label;
      }
      sortElement.innerHTML += `
        <label class="flex items-center gap-8 cursor-pointer">
          <input 
            type="radio" 
            class="size-20 js-sort-option redesign-radio-btn" 
            data-sort="sort.${sort.field}"
            data-sort-order="${sort.direction}"
            data-sort-label="${sort.label}"
            name="sort"
            value="${sort.field}"
            ${checked}
          >
          ${sort.label} 
        </label>
      `;
      this.$sortContent.appendChild(sortElement);
    });
  }
  //------------------------------------------------------------------------------------------------
  toggleSortModal() {
    var _a2, _b;
    if (this.$sortModalWrapper.classList.contains("hidden")) {
      this.$sortModalWrapper.classList.remove("hidden");
      this.$sortButton.setAttribute("aria-expanded", "true");
      this.$sortAscIcon.classList.remove("hidden");
      this.$sortDescIcon.classList.add("hidden");
      window.$lastFocusedEl = document.activeElement;
      trapFocus(this.$sortModal);
      this.$sortModal._onEscape = () => this.toggleSortModal();
    } else {
      this.$sortModalWrapper.classList.add("hidden");
      this.$sortButton.setAttribute("aria-expanded", "false");
      this.$sortAscIcon.classList.add("hidden");
      this.$sortDescIcon.classList.remove("hidden");
      (_b = (_a2 = this.$sortModal)._removeTrapFocus) == null ? void 0 : _b.call(_a2);
      this.$sortModal._onEscape = null;
      if (window.$lastFocusedEl) {
        window.$lastFocusedEl.focus();
      }
    }
  }
  //------------------------------------------------------------------------------------------------
  async handleSortChange() {
    this.pageInfo = 1;
    this.toggleSortModal();
    const url = new URL(window.location.href);
    const urlParams = new URLSearchParams(url.search);
    urlParams.forEach((value, key) => {
      if (key.startsWith("sort.")) {
        urlParams.delete(key);
      }
    });
    if (this.sort) {
      urlParams.set(`${this.sort}`, this.sortOrder);
    }
    window.history.replaceState({}, "", `${url.pathname}?${urlParams.toString()}`);
    this.ssUrl = this.formatSearchSpringUrl();
    const ssData = await this.fetchSearchSpringData();
    this.initPage(ssData, "replace");
    this.$sortLabel.innerHTML = this.sortLabel;
  }
  // **************************************************************************
  // FILTER METHODS 
  // **************************************************************************
  //------------------------------------------------------------------------------------------------
  toggleFiltersDrawer() {
    var _a2, _b;
    if (this.$filtersDrawerWrapper.classList.contains("-translate-x-full")) {
      this.$filtersDrawerWrapper.classList.remove("-translate-x-full");
      this.$filtersDrawerWrapper.classList.add("translate-x-0");
      this.$filtersBackdrop.classList.remove("opacity-0", "pointer-events-none");
      this.$filtersBackdrop.classList.add("opacity-100");
      this.$filtersButton.setAttribute("aria-expanded", "true");
      document.body.classList.add("ui-active", "overflow-hidden");
      window.$lastFocusedEl = document.activeElement;
      trapFocus(this.$filtersDrawer);
      this.$filtersDrawer._onEscape = () => this.toggleFiltersDrawer();
    } else {
      this.$filtersDrawerWrapper.classList.add("-translate-x-full");
      this.$filtersDrawerWrapper.classList.remove("translate-x-0");
      this.$filtersBackdrop.classList.add("opacity-0", "pointer-events-none");
      this.$filtersBackdrop.classList.remove("opacity-100");
      this.$filtersButton.setAttribute("aria-expanded", "false");
      document.body.classList.remove("ui-active", "overflow-hidden");
      (_b = (_a2 = this.$filtersDrawer)._removeTrapFocus) == null ? void 0 : _b.call(_a2);
      this.$filtersDrawer._onEscape = null;
      if (window.$lastFocusedEl) {
        window.$lastFocusedEl.focus();
      }
    }
    this.toggleFilterClearButton();
  }
  //------------------------------------------------------------------------------------------------
  toggleFilterClearButton() {
    if (this.activeFilters && this.activeFilters.length > 0) {
      this.$filtersClearButtonWrapper.classList.remove("hidden");
      this.$filtersContent.classList.add("pb-120");
    } else {
      this.$filtersClearButtonWrapper.classList.add("hidden");
      this.$filtersContent.classList.remove("pb-120");
    }
  }
  //------------------------------------------------------------------------------------------------
  addActiveFilters() {
    if (!this.filtersData || this.filtersData.length === 0) {
      console.warn("No filters available for this collection.");
      return;
    }
    this.filterCounts = {};
    this.$filtersContent.innerHTML = "";
    this.filtersData.forEach((filter) => {
      this.filterCounts[filter.field] = this.countKeyValues(filter.values, "active", true);
      const filterElement = document.createElement("div");
      filterElement.classList.add("filter-item", "border-b-1", "border-charcoal-10");
      filterElement.innerHTML = `
        <button
          type="button"
          id="acc-cta-${filter.field}"
          class="flex items-center justify-between acc__btn js-acc-btn text-charcoal-100 cursor-pointer h-52"
          aria-expanded="false"
          aria-controls="acc-panel-${filter.field}"
        >
          <h3 class="filter-title redesign-label-2 text-charcoal-100">
            ${filter.label}
            <span
              id="filter_count_${filter.field}"
              class="js-filter-count text-charcoal-80 ml-4"
            >(x)</span>
          </h3>
          <span class="accordion-icons flex items-center justify-center size-32 cursor-pointer">
            ${_JK.icons.plus}
            ${_JK.icons.minus}
          </span>
        </button>
        <div
          id="acc-panel-${filter.field}"
          class="pt-22 pb-38 js-acc-menu redesign-body-7 text-charcoal-100"
          role="region"
          aria-labelledby="acc-cta-${filter.field}"
          aria-hidden="true"
          aria-live="polite"
        >
          <ul
            class="filter-options ${filter.label === "Color" ? "grid grid-cols-2 gap-4" : ""}"
            data-filter-group="${filter.field}"
          >
            ${filter.values.map(
        (value) => `
              <li class="filter-option redesign-body-7 py-8">
                <label class="flex items-center gap-10 cursor-pointer">
                  <input
                    type="checkbox"
                    class="js-filter-option redesign-checkbox-btn"
                    data-filter="filter.${filter.field}"
                    data-value="${value.value}"
                    name="${value.value}"
                    value="${value.value}"
                    ${value.active ? "checked" : ""}
                    aria-checked="${value.active ? "true" : "false"}"
                  >
                  <span class="text-charcoal-130 flex flex-row gap-4">
                    ${value.label}
                    <span class="text-charcoal-80 js-filter-count">(${value.count})</span>
                  </span>
                </label>
              </li>
            `
      ).join("")}
          </ul>
        </div>
      `;
      this.$filtersContent.appendChild(filterElement);
    });
  }
  updateFilterStates() {
    if (!this.filtersData || this.filtersData.length === 0) {
      console.warn("No filters to update.");
      return;
    }
    this.filtersData.forEach((filter) => {
      const filterPanel = this.$filtersContent.querySelector(`#acc-panel-${filter.field}`);
      if (!filterPanel) return;
      const list = filterPanel.querySelector("ul.filter-options");
      if (!list) return;
      list.innerHTML = "";
      list.innerHTML = filter.values.map((value) => `
        <li class="filter-option redesign-body-7 py-8">
          <label class="flex items-center gap-10 cursor-pointer">
            <input 
              type="checkbox" 
              class="js-filter-option redesign-checkbox-btn" 
              data-filter="filter.${filter.field}" 
              data-value="${value.value}"
              name="${value.value}" 
              value="${value.value}" 
              ${value.active ? "checked" : ""}
              aria-checked="${value.active ? "true" : "false"}"
            >
            <span class="text-charcoal-130 flex flex-row gap-4">
              ${value.label}
              <span class="text-charcoal-80">(${value.count})</span>
            </span>
          </label>
        </li>
      `).join("");
      const filterCountEl = this.$filtersContent.querySelector(
        `#filter_count_${filter.field}`
      );
      if (filterCountEl) {
        const activeCount = filter.values.filter((v) => v.active).length;
        filterCountEl.textContent = activeCount > 0 ? `(${activeCount})` : "";
      }
    });
  }
  //------------------------------------------------------------------------------------------------
  initFiltersAccordion() {
    if (this.$filtersContent) {
      const accordion = SDG.accordion({
        dom: {
          btn: "js-acc-btn",
          id: this.$filtersContent.id,
          menu: "js-acc-menu"
        },
        open_option: this.activeFilterGroupIndex,
        type: "accordion"
      });
      accordion.init();
      this.$accordionButtons = this.$filtersContent.querySelectorAll(".js-acc-btn");
      this.$accordionButtons.forEach((btn) => {
        btn.addEventListener("click", (e) => {
          e.preventDefault();
          e.stopPropagation();
          this.filterAccordionListener(e);
        });
      });
    }
  }
  //------------------------------------------------------------------------------------------------
  filterAccordionListener(e) {
    const accBtn = e.target.closest(".js-acc-btn");
    this.activeFilterGroupIndex = Number(accBtn.dataset.index);
  }
  //------------------------------------------------------------------------------------------------
  clearFilters() {
    this.$filterOptions = this.$filtersContent.querySelectorAll(".js-filter-option");
    this.$filterOptions.forEach((option) => {
      option.checked = false;
    });
    this.activeFilters = [];
    this.activeFilterGroupIndex = null;
  }
  //------------------------------------------------------------------------------------------------
  async handleFilterChange(filter, value) {
    const url = new URL(window.location.href);
    const urlParams = new URLSearchParams(url.search);
    if (filter !== "" && value !== "") {
      const existingFilterIndex = this.activeFilters.findIndex((f) => f.key === filter && f.value === value);
      if (existingFilterIndex > -1) {
        this.activeFilters.splice(existingFilterIndex, 1);
      } else {
        this.activeFilters.push({ key: filter, value });
      }
      const keysToDelete = [];
      urlParams.forEach((value2, key) => {
        if (key.startsWith("filter.")) {
          keysToDelete.push(key);
        }
      });
      keysToDelete.forEach((key) => {
        urlParams.delete(key);
      });
      this.activeFilters.forEach((filter2) => {
        urlParams.append(filter2.key, filter2.value);
      });
    } else {
      console.log("clear?");
      const keysToDelete = [];
      urlParams.forEach((value2, key) => {
        if (key.startsWith("filter.")) {
          keysToDelete.push(key);
        }
      });
      keysToDelete.forEach((key) => {
        urlParams.delete(key);
      });
      this.activeFilters = [];
    }
    this.pageInfo = 1;
    this.ssUrl = this.formatSearchSpringUrl();
    const ssData = await this.fetchSearchSpringData();
    this.initPage(ssData, "replace");
    this.toggleFilterClearButton();
    const query = urlParams.toString();
    const newUrl = query ? `${url.pathname}?${query}` : url.pathname;
    window.history.replaceState({}, "", newUrl);
  }
  //------------------------------------------------------------------------------------------------
  displayFilterSummary() {
    if (!this.filterSummaryData || this.filterSummaryData.length === 0) {
      this.$filterSummaryWrapper.classList.add("hidden");
      this.$filterSummaryWrapper.classList.remove("flex");
      return;
    }
    this.$filterSummaryWrapper.classList.remove("hidden");
    this.$filterSummaryWrapper.classList.add("flex");
    const summaryItems = this.filterSummaryData.map((filter) => `
      <button 
        class="js-remove-filter h-36 border-1 border-charcoal-10 hover:border-charcoal-40 text-charcoal-80 hover:text-charcoal-100 flex justify-center items-center gap-12 px-14 py-10 whitespace-nowrap"
        data-filter="filter.${filter.field}"
        data-value="${filter.value}"
        aria-label="Remove filter ${filter.label}"
      >
        <span class="filter-summary-item redesign-body-9 ">
          ${filter.label}
        </span>
        <span>${_JK.icons.closeSmall}</span>
      </button>
    `).join(" ");
    this.$filterSummary.innerHTML = summaryItems;
    const removeButtons = this.$filterSummary.querySelectorAll(".js-remove-filter");
    removeButtons.forEach((button) => {
      button.addEventListener("click", (e) => {
        e.preventDefault();
        e.stopPropagation();
        const filterKey = e.currentTarget.dataset.filter;
        const filterValue = e.currentTarget.dataset.value;
        this.handleFilterChange(filterKey, filterValue);
      });
    });
  }
  // **************************************************************************
  // DATA HELPERS 
  // **************************************************************************
  //------------------------------------------------------------------------------------------------
  getSortFromUrl() {
    const url = new URL(window.location.href);
    const urlParams = new URLSearchParams(url.search);
    const sortParams = Array.from(urlParams.entries()).filter(([key]) => key.startsWith("sort.")).map(([key, value]) => ({ key, value }));
    return sortParams;
  }
  //------------------------------------------------------------------------------------------------
  getFiltersFromUrl() {
    const url = new URL(window.location.href);
    const urlParams = new URLSearchParams(url.search);
    const filterParams = Array.from(urlParams.entries()).filter(([key]) => key.startsWith("filter.")).map(([key, value]) => ({ key, value }));
    return filterParams;
  }
  //------------------------------------------------------------------------------------------------
  countKeyValues(arr, key, value) {
    return arr.reduce((count, obj) => {
      if (obj && obj[key] === value) {
        return count + 1;
      }
      return count;
    }, 0);
  }
}
class SRP {
  //------------------------------------------------------------------------------------------------
  constructor() {
    this.$loading = document.getElementById("loading");
    this.$hero = document.getElementById("js-hero");
    this.$noResults = document.getElementById("js-no-results");
    this.$toolbar = document.getElementById("js-toolbar");
    this.$searchContainer = document.getElementById("js-search-results-container");
    this.$productsGridWrapper = document.getElementById("js-products-grid-wrapper");
    this.$productsGrid = document.getElementById("js-products-grid");
    this.$loadMoreProductsButtonWrapper = document.getElementById("js-show-more-products-trigger-wrapper");
    this.$loadMoreProductsButton = document.getElementById("js-show-more-products-trigger");
    this.$totalProductsCounts = document.querySelectorAll(".js-total-products-count");
    this.$currentProductsCount = document.getElementById("js-current-products-count");
    this.$articlesGridWrapper = document.getElementById("js-articles-grid-wrapper");
    this.$articlesGrid = document.getElementById("js-articles-grid");
    this.$loadMoreArticlesButtonWrapper = document.getElementById("js-show-more-articles-trigger-wrapper");
    this.$loadMoreArticlesButton = document.getElementById("js-show-more-articles-trigger");
    this.$totalArticlesCounts = document.querySelectorAll(".js-total-articles-count");
    this.$currentArticlesCount = document.getElementById("js-current-articles-count");
    this.$filtersDrawerWrapper = document.getElementById("js-search-filters-drawer-wrapper");
    this.$filtersBackdrop = document.getElementById("js-search-filters-backdrop");
    this.$filtersDrawer = document.getElementById("js-search-filters-drawer");
    this.$resultTypeFiltersContent = document.getElementById("js-result-type-filters-content");
    this.$productsFiltersContent = document.getElementById("js-products-filters-content");
    this.$articlesFiltersContent = document.getElementById("js-articles-filters-content");
    this.$filtersContent = document.getElementById("js-filters-content");
    this.$filtersButton = document.getElementById("js-filters-trigger");
    this.$filtersCloseButton = document.getElementById("js-close-filters-button");
    this.$filtersApplyButton = document.getElementById("js-apply-filters-button");
    this.$filtersClearButtonWrapper = document.getElementById("js-clear-filters-button-wrapper");
    this.$filtersClearButtons = document.querySelectorAll(".js-clear-filters-button");
    this.$productsFilterCountTotal = document.getElementById("js-products-filter-count-total");
    this.$articlesFilterCountTotal = document.getElementById("js-articles-filter-count-total");
    this.$productsFilterSummaryWrapper = document.getElementById("js-products-filter-summary-wrapper");
    this.$productsFilterSummary = document.getElementById("js-products-filter-summary");
    this.$articlesFilterSummaryWrapper = document.getElementById("js-articles-filter-summary-wrapper");
    this.$articlesFilterSummary = document.getElementById("js-articles-filter-summary");
    this.activeFilterGroupIndex = null;
    this.$sortModalWrapper = document.getElementById("js-search-sort-modal-wrapper");
    this.$sortModal = document.getElementById("js-search-sort-modal");
    this.$sortProductsContent = document.getElementById("js-search-sort-products-content");
    this.$sortArticlesContent = document.getElementById("js-search-sort-articles-content");
    this.$sortButton = document.getElementById("js-search-sort-trigger");
    this.$sortLabel = document.getElementById("js-search-sort-label");
    this.$sortAscIcon = document.getElementById("js-icon-sort-asc");
    this.$sortDescIcon = document.getElementById("js-icon-sort-desc");
    this.ssId = SDG.Data.ssId;
    this.ssBlogId = SDG.Data.ssBlogId;
    this.resultsPerPage = _JK.collections.resultsPerPage || 12;
    this.productsPageInfo = 1;
    this.articlesPageInfo = 1;
    this.q = this.getQueryFromUrl();
    this.url = window.location.href;
    this.urlParams = new URLSearchParams(window.location.search);
    this.resultType = "products";
    this.productsActiveFilters = [];
    this.articlesActiveFilters = [];
    this.sort = null;
    this.sortOrder = null;
    this.ssUrlProducts = this.formatSearchSpringUrl("products");
    this.ssUrlArticles = this.formatSearchSpringUrl("articles");
  }
  /**
     * Normalizes facet data returned from Searchspring before rendering.
     *
     * - For "articles" type:
     *   • Removes any facet values whose label/value starts with "Post:"  
     *   • Strips the "Category:" prefix from the facet label, leaving only the
     *     readable category name (e.g., "Category: Style" → "Style")  
     * - For other types (e.g., "products") the facets are returned unchanged.
     *
     * The facet `value` itself is preserved for Searchspring filtering logic;
     * only the display `label` is modified. Returns a shallow clone of the
     * original data with normalized facet arrays.
     *
     * @param {Object} data - Raw Searchspring response object containing facets
     * @param {string} type - Result type ("articles" or "products")
     * @returns {Object} A copy of the response object with normalized facets
  */
  normalizeFacets(data, type) {
    if (!(data == null ? void 0 : data.facets)) return data;
    const out = { ...data, facets: data.facets.map((facet) => {
      if (facet.field !== "tags" || !Array.isArray(facet.values)) return facet;
      if (type !== "articles") return facet;
      const values = facet.values.filter((v) => !/^post:\s*/i.test(((v == null ? void 0 : v.label) ?? (v == null ? void 0 : v.value) ?? "").trim())).map((v) => ({
        ...v,
        // strip only the display label; keep v.value intact for Searchspring params
        label: ((v == null ? void 0 : v.label) ?? (v == null ? void 0 : v.value) ?? "").replace(/^category:\s*/i, "").trim()
      }));
      return { ...facet, values };
    }) };
    return out;
  }
  //------------------------------------------------------------------------------------------------
  async init() {
    const ssProductData = await this.fetchSearchSpringData("products");
    const ssArticleData = await this.fetchSearchSpringData("articles");
    this.initPage(ssProductData, ssArticleData, "replace", "both");
    if ((ssProductData == null ? void 0 : ssProductData.results.length) > 0 || (ssArticleData == null ? void 0 : ssArticleData.results.length) > 0) {
      this.initSort();
      this.addEventListeners();
    }
  }
  //------------------------------------------------------------------------------------------------
  initPage(ssProductData, ssArticleData, action = "replace", resultType = "both") {
    let displayType = resultType;
    if (ssArticleData) ssArticleData = this.normalizeFacets(ssArticleData, "articles");
    if (!ssProductData && !ssArticleData || (ssProductData == null ? void 0 : ssProductData.results.length) === 0 && (ssArticleData == null ? void 0 : ssArticleData.results.length) === 0) {
      this.displayNoResults();
      return;
    } else if ((ssProductData == null ? void 0 : ssProductData.results.length) === 0 && (ssArticleData == null ? void 0 : ssArticleData.results.length) > 0) {
      displayType = "articles";
    }
    if (action === "replace") {
      this.clearResults(resultType);
    }
    this.$loading.classList.add("hidden");
    if (resultType === "products" || resultType === "both") {
      this.productsData = ssProductData.results;
      this.productsFiltersData = ssProductData.facets || [];
      this.productsSortData = ssProductData.sorting || [];
      this.productsFilterSummaryData = ssProductData.filterSummary || {};
      this.productsPaginationData = ssProductData.pagination || {};
      this.displayProducts(action);
    }
    if (resultType === "articles" || resultType === "both") {
      this.articlesData = ssArticleData.results;
      this.articlesFiltersData = ssArticleData.facets || [];
      this.articlesSortData = ssArticleData.sorting || [];
      this.articlesFilterSummaryData = ssArticleData.filterSummary || {};
      this.articlesPaginationData = ssArticleData.pagination || {};
      this.displayArticles(action);
    }
    if (!this.filtersInitialized) {
      this.addActiveFilters();
      this.initFiltersAccordion();
      this.filtersInitialized = true;
    } else {
      this.filtersData = resultType === "articles" ? ssArticleData.facets : ssProductData.facets;
      this.updateFilterStates();
    }
    this.toggleResultType(displayType);
    this.updateCounts();
    this.$toolbar.classList.remove("hidden");
    this.$hero.classList.remove("hidden");
    this.updateSearchHistory(this.q);
  }
  updateFilterStates() {
    if (!this.filtersData || this.filtersData.length === 0) {
      console.warn("No filters to update.");
      return;
    }
    this.filtersData.forEach((filter, index) => {
      var _a2;
      const filterPanel = this.$filtersContent.querySelector(`#acc-panel-${filter.field}`);
      if (!filterPanel) {
        console.warn(`No filter panel found for index ${index}`, filter);
        return;
      }
      const list = filterPanel.querySelector("ul.filter-options");
      if (!list) return;
      list.innerHTML = filter.values.map((value) => `
        <li class="filter-option redesign-body-7 py-8">
          <label class="flex items-center gap-10 cursor-pointer">
            <input 
              type="checkbox" 
              class="js-filter-option redesign-checkbox-btn" 
              data-filter="filter.${filter.field}" 
              data-value="${value.value}"
              name="${value.value}" 
              value="${value.value}" 
              ${value.active ? "checked" : ""}
              aria-checked="${value.active ? "true" : "false"}"
            >
            <span class="text-charcoal-130 flex flex-row gap-4">
              ${value.label}
              <span class="text-charcoal-80">(${value.count})</span>
            </span>
          </label>
        </li>
      `).join("");
      const filterCountEl = (_a2 = filterPanel.closest(".filter-item")) == null ? void 0 : _a2.querySelector(`#filter_count_${filter.field}`);
      if (filterCountEl) {
        const activeCount = filter.values.filter((v) => v.active).length;
        filterCountEl.textContent = activeCount > 0 ? `(${activeCount})` : "";
      }
    });
  }
  updateFilterCount(panel, values) {
    const counterEl = panel.querySelector(".filter-count");
    if (!counterEl) return;
    const activeCount = values.filter((v) => v.active).length;
    counterEl.textContent = activeCount > 0 ? `(${activeCount})` : "";
  }
  // **************************************************************************
  // EVENTS
  // **************************************************************************
  //------------------------------------------------------------------------------------------------
  addEventListeners() {
    [
      this.$filtersButton,
      this.$filtersBackdrop,
      this.$filtersCloseButton,
      this.$filtersApplyButton
    ].forEach((el) => {
      el.addEventListener("click", (e) => {
        e.preventDefault();
        e.stopPropagation();
        this.toggleFiltersDrawer();
      });
    });
    this.$filtersClearButtons.forEach((button) => {
      button.addEventListener("click", (e) => {
        e.preventDefault();
        e.stopPropagation();
        this.clearFilters();
        this.handleFilterChange("", "");
      });
    });
    this.addFilterOptionListeners();
    this.$sortButton.addEventListener("click", (e) => {
      e.preventDefault();
      this.toggleSortModal();
    });
    const sortProductsOptions = this.$sortProductsContent.querySelectorAll(".js-sort-option");
    sortProductsOptions.forEach((option) => {
      option.addEventListener("change", (e) => {
        var _a2, _b, _c;
        e.preventDefault();
        e.stopPropagation();
        this.sort = ((_a2 = e.target.dataset) == null ? void 0 : _a2.sort) || null;
        this.sortLabel = ((_b = e.target.dataset) == null ? void 0 : _b.sortLabel) || null;
        this.sortOrder = ((_c = e.target.dataset) == null ? void 0 : _c.sortOrder) || null;
        this.handleSortChange("products");
      });
    });
    const sortArticlesOptions = this.$sortArticlesContent.querySelectorAll(".js-sort-option");
    sortArticlesOptions.forEach((option) => {
      option.addEventListener("change", (e) => {
        var _a2, _b, _c;
        e.preventDefault();
        e.stopPropagation();
        this.sort = ((_a2 = e.target.dataset) == null ? void 0 : _a2.sort) || null;
        this.sortLabel = ((_b = e.target.dataset) == null ? void 0 : _b.sortLabel) || null;
        this.sortOrder = ((_c = e.target.dataset) == null ? void 0 : _c.sortOrder) || null;
        this.handleSortChange("articles");
      });
    });
    this.$loadMoreProductsButton.addEventListener("click", (e) => {
      e.preventDefault();
      e.stopPropagation();
      debounce(this.showMoreProducts(), 300);
    });
    this.$loadMoreArticlesButton.addEventListener("click", (e) => {
      e.preventDefault();
      e.stopPropagation();
      debounce(this.showMoreArticles(), 300);
    });
  }
  //------------------------------------------------------------------------------------------------
  addFilterOptionListeners() {
    this.$filtersContent.addEventListener("change", (e) => {
      if (e.target.matches('.js-filter-option[type="checkbox"]') && e.target instanceof HTMLInputElement) {
        const input = e.target;
        const filterKey = input.dataset.filter;
        const filterValue = input.dataset.value;
        this.handleFilterChange(filterKey, filterValue);
      }
    });
    this.$resultTypeFiltersContent.addEventListener("change", (e) => {
      if (e.target.matches('.js-filter-option[type="radio"]') && e.target instanceof HTMLInputElement) {
        const input = e.target;
        const filterValue = input.dataset.value;
        this.toggleResultType(filterValue);
      }
    });
  }
  // **************************************************************************
  // SEARCHSPRING METHODS
  // **************************************************************************
  //------------------------------------------------------------------------------------------------
  async fetchSearchSpringData(resultType = "products") {
    const ssUrl = resultType === "products" ? this.ssUrlProducts : this.ssUrlArticles;
    try {
      const response = await fetch(ssUrl);
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      const data = await response.json();
      return data;
    } catch (error) {
      console.error("Error fetching SS Data:", error);
      console.error(`  - ERR ssURL: ${ssUrl}`);
      return null;
    }
  }
  //------------------------------------------------------------------------------------------------
  formatSearchSpringUrl(resultType = "products") {
    const {
      sessionCookie,
      userId,
      pageLoadId
    } = setAndGetSearchspringCookies();
    let ssId = this.ssId;
    let pageInfo = this.productsPageInfo;
    if (resultType === "articles") {
      ssId = this.ssBlogId;
      pageInfo = this.articlesPageInfo;
    }
    const ssBaseUrl = `https://${ssId}.a.searchspring.io/api/search/search.json`;
    const ssParams = new URLSearchParams({
      resultsFormat: "native",
      siteId: ssId,
      sessionId: sessionCookie,
      userId,
      pageLoadId,
      resultsPerPage: this.resultsPerPage,
      page: pageInfo,
      q: this.q
    });
    if (resultType === "products" && this.productsActiveFilters) {
      this.productsActiveFilters.forEach((filter) => {
        ssParams.append(filter.key, filter.value);
      });
    }
    if (resultType === "articles" && this.articlesActiveFilters) {
      this.articlesActiveFilters.forEach((filter) => {
        ssParams.append(filter.key, filter.value);
      });
    }
    if (this.sort && this.sortOrder) {
      ssParams.append(`${this.sort}`, this.sortOrder);
    }
    const ssUrl = `${ssBaseUrl}?${ssParams.toString()}`;
    return ssUrl;
  }
  // **************************************************************************
  // DISPLAY RESULTS METHODS 
  // **************************************************************************
  //------------------------------------------------------------------------------------------------
  toggleResultType(resultType = "products") {
    if (resultType === "both") resultType = "products";
    this.resultType = resultType;
    this.$radioResultTypeProducts = document.getElementById("resulttype.products");
    this.$radioResultTypeArticles = document.getElementById("resulttype.articles");
    this.$productsGridWrapper.classList.add("hidden");
    this.$productsFilterCountTotal.classList.add("hidden");
    this.$productsFiltersContent.classList.add("hidden");
    this.$sortProductsContent.classList.add("hidden");
    this.$productsFilterSummaryWrapper.classList.add("hidden");
    this.$radioResultTypeProducts.checked = false;
    this.$articlesGridWrapper.classList.add("hidden");
    this.$articlesFilterCountTotal.classList.add("hidden");
    this.$articlesFiltersContent.classList.add("hidden");
    this.$sortArticlesContent.classList.add("hidden");
    this.$articlesFilterSummaryWrapper.classList.add("hidden");
    this.$radioResultTypeArticles.checked = false;
    if (resultType === "products") {
      this.$productsGridWrapper.classList.remove("hidden");
      this.$productsFilterCountTotal.classList.remove("hidden");
      this.$productsFiltersContent.classList.remove("hidden");
      this.$sortProductsContent.classList.remove("hidden");
      this.$radioResultTypeProducts.checked = true;
    } else {
      this.$articlesGridWrapper.classList.remove("hidden");
      this.$articlesFilterCountTotal.classList.remove("hidden");
      this.$articlesFiltersContent.classList.remove("hidden");
      this.$sortArticlesContent.classList.remove("hidden");
      this.$radioResultTypeArticles.checked = true;
    }
    this.displayFilterSummary(resultType);
  }
  //------------------------------------------------------------------------------------------------
  displayArticles(action) {
    if (!this.articlesData || this.articlesData.length === 0) {
      this.$articlesGrid.innerHTML = '<p class="redesign-body-4 text-charcoal-100 col-span-3 text-center">No resuls with those filters.</p>';
      return;
    }
    if (action === "append") {
      this.articlesData.forEach((article) => {
        const articleCard = document.createElement("div");
        articleCard.classList.add("article-card", "basis-[calc(50%-4px)]", "lg:basis-1/4");
        articleCard.innerHTML = this.getArticleCardHTML(article);
        this.$articlesGrid.appendChild(articleCard);
      });
    } else {
      this.$articlesGrid.innerHTML = this.articlesData.map((article) => `
        <div class="article-card basis-[calc(50%-4px)] lg:basis-1/4">
          ${this.getArticleCardHTML(article)}
        </div>
      `).join("");
    }
    if (this.articlesPaginationData.currentPage < this.articlesPaginationData.totalPages) {
      this.$loadMoreArticlesButtonWrapper.classList.remove("hidden");
    } else {
      this.$loadMoreArticlesButtonWrapper.classList.add("hidden");
    }
  }
  //------------------------------------------------------------------------------------------------
  getArticleCardHTML(article) {
    return `
      <a href="${article.url}">
        <article class="text-charcoal-100">
          <div class="aspect-[1.475] bg-no-repeat bg-cover bg-top mb-16" style="background-image: url('${article.thumbnailImageUrl.replace(/(\.(jpg|jpeg|png|gif|webp))(?=\?|$)/i, "_800x$1")}');"></div>
          <h3 class="redesign-body-5 mb-12">${article.title}</h3>
          <p class="redesign-body-7">${article.content === void 0 ? article.title : article.content}</p>
        </article>
      </a>
    `;
  }
  //------------------------------------------------------------------------------------------------
  displayProducts(action) {
    var _a2, _b;
    if (!this.productsData || this.productsData.length === 0) {
      this.$productsGrid.innerHTML = "<p>No products available in this collection.</p>";
      return;
    }
    intelliSuggest(this.productsData);
    const handlesToRender = this.productsData.map((product) => product.handle);
    renderProductCardsFromHandles(
      handlesToRender,
      this.$productsGrid,
      {
        view: "get-product-card",
        cardClasses: ["basis-[calc(50%-4px)]", "lg:basis-1/4"],
        action
      }
    );
    if (((_a2 = this.productsPaginationData) == null ? void 0 : _a2.currentPage) < ((_b = this.productsPaginationData) == null ? void 0 : _b.totalPages)) {
      this.$loadMoreProductsButtonWrapper.classList.remove("hidden");
    } else {
      this.$loadMoreProductsButtonWrapper.classList.add("hidden");
    }
  }
  //------------------------------------------------------------------------------------------------
  showMoreProducts() {
    this.productsPageInfo += 1;
    this.ssUrlProducts = this.formatSearchSpringUrl("products");
    this.fetchSearchSpringData("products").then((ssProductData) => {
      this.initPage(ssProductData, null, "append", "products");
    }).catch((error) => {
      console.error("Error fetching more products:", error);
      this.$loadMoreButtonWrapper.classList.add("hidden");
    });
  }
  //------------------------------------------------------------------------------------------------
  showMoreArticles() {
    this.articlesPageInfo += 1;
    this.ssUrlArticles = this.formatSearchSpringUrl("articles");
    this.fetchSearchSpringData("articles").then((ssArticlesData) => {
      this.initPage(null, ssArticlesData, "append", "articles");
    }).catch((error) => {
      console.error("Error fetching more articles:", error);
      this.$loadMoreButtonWrapper.classList.add("hidden");
    });
  }
  //------------------------------------------------------------------------------------------------
  clearResults(resultType = "products") {
    if (resultType === "products") {
      this.$productsGrid.innerHTML = "";
    } else {
      this.$articlesGrid.innerHTML = "";
    }
  }
  //------------------------------------------------------------------------------------------------
  updateCounts() {
    var _a2, _b;
    this.$totalProductsCounts = document.querySelectorAll(".js-total-products-count");
    this.$totalArticlesCounts = document.querySelectorAll(".js-total-articles-count");
    this.$totalProductsCounts.forEach((el) => {
      var _a3;
      el.innerHTML = ((_a3 = this.productsPaginationData) == null ? void 0 : _a3.totalResults) || 0;
    });
    this.$totalArticlesCounts.forEach((el) => {
      var _a3;
      el.innerHTML = ((_a3 = this.articlesPaginationData) == null ? void 0 : _a3.totalResults) || 0;
    });
    this.$currentProductsCount.innerHTML = ((_a2 = this.productsPaginationData) == null ? void 0 : _a2.end) || 0;
    this.$currentArticlesCount.innerHTML = ((_b = this.articlesPaginationData) == null ? void 0 : _b.end) || 0;
    if (this.productsActiveFilters) {
      if (this.productsActiveFilters.length > 0) {
        this.$productsFilterCountTotal.innerHTML = `(${this.productsActiveFilters.length})`;
      } else {
        this.$productsFilterCountTotal.innerHTML = "";
      }
    }
    if (this.articlesActiveFilters) {
      if (this.articlesActiveFilters.length > 0) {
        this.$articlesFilterCountTotal.innerHTML = `(${this.articlesActiveFilters.length})`;
      } else {
        this.$articlesFilterCountTotal.innerHTML = "";
      }
    }
    for (var filter in this.filterCounts) {
      const count = this.filterCounts[filter] === 0 ? "" : `(${this.filterCounts[filter]})`;
      const counterID = `filter_count_${filter}`;
      const $counter = document.getElementById(counterID);
      $counter.innerHTML = count;
    }
  }
  //------------------------------------------------------------------------------------------------
  displayNoResults() {
    this.$loading.classList.add("hidden");
    this.$noResults.classList.remove("hidden");
    document.getElementById("noResultsQ").focus();
  }
  // **************************************************************************
  // SORT METHODS 
  // **************************************************************************
  //------------------------------------------------------------------------------------------------
  initSort() {
    this.$sortProductsContent.innerHTML = "";
    this.$sortArticlesContent.innerHTML = "";
    let anyActive = false;
    this.productsSortData.options.forEach((sort, index) => {
      const sortElement = document.createElement("div");
      sortElement.classList.add("redesign-body-7", "text-charcoal-100", "py-8");
      let checked = "";
      if (sort.active) {
        sortElement.classList.add("active");
        checked = "checked";
        anyActive = true;
        this.$sortLabel.innerHTML = sort.label;
      }
      if (!anyActive && index === 0) {
        checked = "checked";
        this.$sortLabel.innerHTML = sort.label;
      }
      sortElement.innerHTML += `
          <label class="flex items-center gap-8 cursor-pointer gtm-sort" data-handle="${sort.label} : ${sort.direction}">
            <input 
              type="radio" 
              class="size-20 js-sort-option redesign-radio-btn" 
              data-sort="sort.${sort.field}"
              data-sort-order="${sort.direction}"
              data-sort-label="${sort.label}"
              name="sort"
              value="${sort.field}"
              ${checked}
            >
            ${sort.label} 
          </label>
      `;
      this.$sortProductsContent.appendChild(sortElement);
    });
    anyActive = false;
    this.articlesSortData.options.forEach((sort, index) => {
      const sortElement = document.createElement("div");
      sortElement.classList.add("redesign-body-7", "text-charcoal-100", "py-8");
      let checked = "";
      if (sort.active) {
        sortElement.classList.add("active");
        checked = "checked";
        anyActive = true;
        this.$sortLabel.innerHTML = sort.label;
      }
      if (!anyActive && index === 0) {
        checked = "checked";
        this.$sortLabel.innerHTML = sort.label;
      }
      sortElement.innerHTML += `
          <label class="flex items-center gap-8 cursor-pointer">
            <input 
              type="radio" 
              class="size-20 js-sort-option redesign-radio-btn" 
              data-sort="sort.${sort.field}"
              data-sort-order="${sort.direction}"
              data-sort-label="${sort.label}"
              name="sort-articles"
              value="${sort.field}"
              ${checked}
            >
            ${sort.label} 
          </label>
      `;
      this.$sortArticlesContent.appendChild(sortElement);
    });
  }
  //------------------------------------------------------------------------------------------------
  toggleSortModal() {
    var _a2, _b;
    if (this.$sortModalWrapper.classList.contains("hidden")) {
      this.$sortModalWrapper.classList.remove("hidden");
      this.$sortButton.setAttribute("aria-expanded", "true");
      document.body.classList.add("ui-active");
      this.$sortAscIcon.classList.remove("hidden");
      this.$sortDescIcon.classList.add("hidden");
      window.$lastFocusedEl = document.activeElement;
      trapFocus(this.$sortModal);
      this.$sortModal._onEscape = () => this.toggleSortModal();
    } else {
      this.$sortModalWrapper.classList.add("hidden");
      this.$sortButton.setAttribute("aria-expanded", "false");
      document.body.classList.remove("ui-active");
      this.$sortAscIcon.classList.add("hidden");
      this.$sortDescIcon.classList.remove("hidden");
      (_b = (_a2 = this.$sortModal)._removeTrapFocus) == null ? void 0 : _b.call(_a2);
      this.$sortModal._onEscape = null;
      if (window.$lastFocusedEl) {
        window.$lastFocusedEl.focus();
      }
    }
  }
  //------------------------------------------------------------------------------------------------
  async handleSortChange(resultType = "products") {
    this.toggleSortModal();
    if (resultType === "products") {
      this.productsPageInfo = 1;
      this.ssUrlProducts = this.formatSearchSpringUrl("products");
      const ssProductData = await this.fetchSearchSpringData("products");
      this.initPage(ssProductData, null, "replace", "products");
    } else {
      this.articlesPageInfo = 1;
      this.ssUrlArticles = this.formatSearchSpringUrl("articles");
      const ssArticleData = await this.fetchSearchSpringData("articles");
      this.initPage(null, ssArticleData, "replace", "articles");
    }
    this.$sortLabel.innerHTML = this.sortLabel;
  }
  // **************************************************************************
  // FILTER METHODS 
  // **************************************************************************
  //------------------------------------------------------------------------------------------------
  toggleFiltersDrawer() {
    var _a2, _b;
    if (this.$filtersDrawerWrapper.classList.contains("-translate-x-full")) {
      this.$filtersDrawerWrapper.classList.remove("-translate-x-full");
      this.$filtersDrawerWrapper.classList.add("translate-x-0");
      this.$filtersBackdrop.classList.remove("opacity-0", "pointer-events-none");
      this.$filtersBackdrop.classList.add("opacity-100");
      this.$filtersButton.setAttribute("aria-expanded", "true");
      document.body.classList.add("ui-active", "overflow-hidden");
      window.$lastFocusedEl = document.activeElement;
      trapFocus(this.$filtersDrawer);
      this.$filtersDrawer._onEscape = () => this.toggleFiltersDrawer();
    } else {
      this.$filtersDrawerWrapper.classList.add("-translate-x-full");
      this.$filtersDrawerWrapper.classList.remove("translate-x-0");
      this.$filtersBackdrop.classList.add("opacity-0", "pointer-events-none");
      this.$filtersBackdrop.classList.remove("opacity-100");
      this.$filtersButton.setAttribute("aria-expanded", "false");
      document.body.classList.remove("ui-active", "overflow-hidden");
      (_b = (_a2 = this.$filtersDrawer)._removeTrapFocus) == null ? void 0 : _b.call(_a2);
      this.$filtersDrawer._onEscape = null;
      if (window.$lastFocusedEl) {
        window.$lastFocusedEl.focus();
      }
    }
    this.toggleFilterClearButton();
  }
  //------------------------------------------------------------------------------------------------
  toggleFilterClearButton() {
    if (this.productsActiveFilters && this.productsActiveFilters.length > 0 || this.articlesActiveFilters && this.articlesActiveFilters.length > 0) {
      this.$filtersClearButtonWrapper.classList.remove("hidden");
      this.$filtersContent.classList.add("pb-120");
    } else {
      this.$filtersClearButtonWrapper.classList.add("hidden");
      this.$filtersContent.classList.remove("pb-120");
    }
  }
  //------------------------------------------------------------------------------------------------
  addActiveFilters() {
    var _a2, _b;
    if (!((_a2 = this.productsFiltersData) == null ? void 0 : _a2.length) && !((_b = this.articlesFiltersData) == null ? void 0 : _b.length)) {
      console.warn("No filters available.");
      return;
    }
    if (!this.filtersInitialized) {
      this.$productsFiltersContent.innerHTML = "";
      this.$articlesFiltersContent.innerHTML = "";
    }
    if (!this.filtersInitialized) {
      this.buildFiltersUI(this.productsFiltersData, this.$productsFiltersContent);
      this.buildFiltersUI(this.articlesFiltersData, this.$articlesFiltersContent);
      this.filtersInitialized = true;
    }
    if (!this.eventsBound) {
      this.bindFilterEvents();
      this.eventsBound = true;
    }
  }
  buildFiltersUI(filtersData, container) {
    filtersData.forEach((filter) => {
      const filterElement = document.createElement("div");
      filterElement.classList.add("filter-item", "border-b-1", "border-charcoal-10");
      filterElement.innerHTML = `
        <button 
          type="button"
          id="acc-cta-${filter.field}" 
          class="flex items-center justify-between acc__btn js-acc-btn text-charcoal-100 cursor-pointer h-52"
          data-field="${filter.field}"
          aria-expanded="false" 
          aria-controls="acc-panel-${filter.field}"
        >
          <h3 class="filter-title redesign-label-2 text-charcoal-100">
            ${filter.label}
            <span 
              id="filter_count_${filter.field}"
              class="js-filter-count text-charcoal-80 ml-4"
              aria-live="polite"
            ></span>
          </h3>
          <span class="accordion-icons flex items-center justify-center size-32">
            ${_JK.icons.plus}
            ${_JK.icons.minus}
          </span>
        </button>
        <div id="acc-panel-${filter.field}" class="pt-22 pb-38 js-acc-menu" aria-hidden="true">
          <ul class="filter-options ${filter.label === "Color" || filter.label === "Size" ? "grid grid-cols-2 gap-4" : ""}">
            ${filter.values.map((value) => `
              <li class="filter-option redesign-body-7 py-8">
                <label class="flex items-center gap-10 cursor-pointer">
                  <input 
                    type="checkbox" 
                    class="js-filter-option redesign-checkbox-btn" 
                    data-filter="filter.${filter.field}" 
                    data-value="${value.value}"
                    ${value.active ? "checked" : ""}
                  >
                  <span class="text-charcoal-130 flex flex-row gap-4">
                    ${value.label}
                    <span class="text-charcoal-80">(${value.count})</span>
                  </span>
                </label>
              </li>
            `).join("")}
          </ul>
        </div>
      `;
      container.appendChild(filterElement);
    });
  }
  bindFilterEvents() {
    if (this.$productsFiltersContent) {
      this.$productsFiltersContent.addEventListener("change", (e) => {
        const target = e.target.closest(".js-filter-option");
        if (!target) return;
        e.stopPropagation();
        const filter = target.dataset.filter;
        const value = target.dataset.value;
        this.handleFilterChange(filter, value, target.checked);
      });
    }
    if (this.$articlesFiltersContent) {
      this.$articlesFiltersContent.addEventListener("change", (e) => {
        const target = e.target.closest(".js-filter-option");
        if (!target) return;
        e.stopPropagation();
        const filter = target.dataset.filter;
        const value = target.dataset.value;
        this.handleFilterChange(filter, value, target.checked);
      });
    }
  }
  //------------------------------------------------------------------------------------------------
  initFiltersAccordion() {
    if (this.resultType === "products") {
      this.$productsFiltersContent.classList.remove("hidden");
    } else {
      this.$articlesFiltersContent.classList.remove("hidden");
    }
    if (this.$filtersContent) {
      const accordion = SDG.accordion({
        dom: {
          btn: "js-acc-btn",
          id: this.$filtersContent.id,
          menu: "js-acc-menu"
        },
        open_option: this.activeFilterGroupIndex,
        type: "accordion"
      });
      accordion.init();
      this.$accordionButtons = this.$filtersContent.querySelectorAll(".js-acc-btn");
      this.$accordionButtons.forEach((btn) => {
        btn.addEventListener("click", (e) => {
          e.preventDefault();
          e.stopPropagation();
          this.filterAccordionListener(e);
        });
      });
    }
  }
  //------------------------------------------------------------------------------------------------
  filterAccordionListener(e) {
    const accBtn = e.target.closest(".js-acc-btn");
    this.activeFilterGroupIndex = Number(accBtn.dataset.index);
  }
  //------------------------------------------------------------------------------------------------
  clearFilters() {
    this.$filterOptions = this.$filtersContent.querySelectorAll(".js-filter-option");
    this.$filterOptions.forEach((option) => {
      option.checked = false;
    });
    this.productsActiveFilters = [];
    this.articlesActiveFilters = [];
  }
  //------------------------------------------------------------------------------------------------
  async handleFilterChange(filter, value) {
    if (filter !== "" && value !== "") {
      if (this.resultType === "products") {
        const existingProductsFilterIndex = this.productsActiveFilters.findIndex((f) => f.key === filter && f.value === value);
        if (existingProductsFilterIndex > -1) {
          this.productsActiveFilters.splice(existingProductsFilterIndex, 1);
        } else {
          this.productsActiveFilters.push({ key: filter, value });
        }
      } else {
        const existingArticlesFilterIndex = this.articlesActiveFilters.findIndex((f) => f.key === filter && f.value === value);
        if (existingArticlesFilterIndex > -1) {
          this.articlesActiveFilters.splice(existingArticlesFilterIndex, 1);
        } else {
          this.articlesActiveFilters.push({ key: filter, value });
        }
      }
    } else {
      this.productsActiveFilters = [];
      this.articlesActiveFilters = [];
    }
    if (this.resultType === "products") {
      this.productsPageInfo = 1;
      this.ssUrlProducts = this.formatSearchSpringUrl("products");
      const ssProductData = await this.fetchSearchSpringData("products");
      this.initPage(ssProductData, null, "replace", "products");
    } else {
      this.articlesPageInfo = 1;
      this.ssUrlArticles = this.formatSearchSpringUrl("articles");
      const ssArticleData = await this.fetchSearchSpringData("articles");
      this.initPage(null, ssArticleData, "replace", "articles");
    }
    this.toggleFilterClearButton();
  }
  //------------------------------------------------------------------------------------------------
  displayFilterSummary(displayType = "products") {
    if (displayType === "products" || displayType === "both") {
      if (!this.productsFilterSummaryData || this.productsFilterSummaryData.length === 0) {
        this.$productsFilterSummaryWrapper.classList.add("hidden");
        this.$productsFilterSummaryWrapper.classList.remove("flex");
      } else {
        this.$productsFilterSummaryWrapper.classList.remove("hidden");
        this.$productsFilterSummaryWrapper.classList.add("flex");
        const productsSummaryItems = this.productsFilterSummaryData.map((filter) => `
          <button 
            class="js-remove-filter h-36 border-1 border-charcoal-10 hover:border-charcoal-40 text-charcoal-80 hover:text-charcoal-100 flex justify-center items-center gap-12 px-14 py-10 whitespace-nowrap"
            data-filter="filter.${filter.field}"
            data-value="${filter.value}"
            aria-label="Remove filter ${filter.label}"
          >
            <span class="filter-summary-item redesign-body-9">
              ${filter.label}
            </span>
            <span>${_JK.icons.closeSmall}</span>
          </button>
        `).join(" ");
        this.$productsFilterSummary.innerHTML = productsSummaryItems;
      }
    }
    if (displayType === "articles" || displayType === "both") {
      if (!this.articlesFilterSummaryData || this.articlesFilterSummaryData.length === 0) {
        this.$articlesFilterSummaryWrapper.classList.add("hidden");
        this.$articlesFilterSummaryWrapper.classList.remove("flex");
      } else {
        this.$articlesFilterSummaryWrapper.classList.remove("hidden");
        this.$articlesFilterSummaryWrapper.classList.add("flex");
        const articlesSummaryItems = this.articlesFilterSummaryData.map((filter) => `
          <button 
            class="js-remove-filter h-36 border-1 border-charcoal-10 hover:border-charcoal-40 text-charcoal-80 hover:text-charcoal-100 flex justify-center items-center gap-12 px-14 py-10 whitespace-nowrap"
            data-filter="filter.${filter.field}"
            data-value="${filter.value}"
            aria-label="Remove filter ${filter.label}"
          >
            <span class="filter-summary-item redesign-body-9">
              ${filter.label.replace(/Category:\s*/g, "")}
            </span>
            <span>${_JK.icons.closeSmall}</span>
          </button>
        `).join(" ");
        this.$articlesFilterSummary.innerHTML = articlesSummaryItems;
      }
    }
    const removeButtons = document.querySelectorAll(".js-remove-filter");
    removeButtons.forEach((button) => {
      button.addEventListener("click", (e) => {
        e.preventDefault();
        e.stopPropagation();
        const filterKey = e.currentTarget.dataset.filter;
        const filterValue = e.currentTarget.dataset.value;
        this.handleFilterChange(filterKey, filterValue);
      });
    });
  }
  // **************************************************************************
  // DATA HELPERS 
  // **************************************************************************
  //------------------------------------------------------------------------------------------------
  getQueryFromUrl() {
    const url = new URL(window.location.href);
    const urlParams = new URLSearchParams(url.search);
    const params = Array.from(urlParams.entries()).filter(([key]) => key === "q").map(([key, value]) => ({ key, value }));
    const q = params.length > 0 ? params[0].value : "no-results";
    return q;
  }
  //------------------------------------------------------------------------------------------------
  countKeyValues(arr, key, value) {
    return arr.reduce((count, obj) => {
      if (obj && obj[key] === value) {
        return count + 1;
      }
      return count;
    }, 0);
  }
  /**
  * updateSearchHistory
  * --------------------
  * Saves the current search query to localStorage under the key "search-history".
  * - Skips if the query is blank.
  * - Prevents duplicates (won’t re-add the same query).
  * - Maintains a maximum of 8 stored queries (removes the oldest when full).
  * - Used on the Search Results Page to persist a short history of searches
  *   that can be re-used by other components (e.g., header search).
  *
  * @param {string} q - The search query string
  */
  updateSearchHistory(q) {
    if (!q || q.trim() === "") return;
    const qList = [q];
    const searchHistoryMax = 8;
    const searchHistoryKey = "search-history";
    const localData = localStorage.getItem(searchHistoryKey);
    if (!localData) {
      localStorage.setItem(searchHistoryKey, JSON.stringify(qList));
    } else {
      let parsed = JSON.parse(localData);
      const sameQ = parsed.includes(q);
      if (!sameQ) {
        if (parsed.length >= searchHistoryMax) {
          parsed.shift();
        }
        parsed.push(q);
        localStorage.setItem(searchHistoryKey, JSON.stringify(parsed));
      }
    }
  }
}
document.addEventListener("DOMContentLoaded", () => {
  var _a2, _b, _c;
  const header = new HeaderHandler();
  header.init();
  header.handleAccountLinkClick();
  header.initSearchModal(".modal-search", ".header-utility--search, .header-utility--search-mobile", "#close-search-modal");
  const cartComponent = new CartComponent();
  cartComponent.init();
  new CustomFooter();
  lazyLoadImages();
  window._JK = window._JK || {};
  const $collectionContainer = document.getElementById("js-collection-container");
  if ($collectionContainer) {
    const collection = new Collection();
    collection.init();
  }
  const $searchResultsContainer = document.getElementById("js-search-results-container");
  if ($searchResultsContainer) {
    const srp = new SRP();
    srp.init();
  }
  if ((_c = (_b = (_a2 = window.SDG) == null ? void 0 : _a2.Site) == null ? void 0 : _b.update_tab_title) == null ? void 0 : _c.enable) {
    updateTabTitle();
  }
});
const scriptRel = "modulepreload";
const assetsURL = function(dep, importerUrl) {
  return new URL(dep, importerUrl).href;
};
const seen = {};
const __vitePreload = function preload(baseModule, deps, importerUrl) {
  let promise = Promise.resolve();
  if (deps && deps.length > 0) {
    const links = document.getElementsByTagName("link");
    const cspNonceMeta = document.querySelector(
      "meta[property=csp-nonce]"
    );
    const cspNonce = (cspNonceMeta == null ? void 0 : cspNonceMeta.nonce) || (cspNonceMeta == null ? void 0 : cspNonceMeta.getAttribute("nonce"));
    promise = Promise.allSettled(
      deps.map((dep) => {
        dep = assetsURL(dep, importerUrl);
        if (dep in seen) return;
        seen[dep] = true;
        const isCss = dep.endsWith(".css");
        const cssSelector = isCss ? '[rel="stylesheet"]' : "";
        const isBaseRelative = !!importerUrl;
        if (isBaseRelative) {
          for (let i = links.length - 1; i >= 0; i--) {
            const link2 = links[i];
            if (link2.href === dep && (!isCss || link2.rel === "stylesheet")) {
              return;
            }
          }
        } else if (document.querySelector(`link[href="${dep}"]${cssSelector}`)) {
          return;
        }
        const link = document.createElement("link");
        link.rel = isCss ? "stylesheet" : scriptRel;
        if (!isCss) {
          link.as = "script";
        }
        link.crossOrigin = "";
        link.href = dep;
        if (cspNonce) {
          link.setAttribute("nonce", cspNonce);
        }
        document.head.appendChild(link);
        if (isCss) {
          return new Promise((res, rej) => {
            link.addEventListener("load", res);
            link.addEventListener(
              "error",
              () => rej(new Error(`Unable to preload CSS for ${dep}`))
            );
          });
        }
      })
    );
  }
  function handlePreloadError(err) {
    const e = new Event("vite:preloadError", {
      cancelable: true
    });
    e.payload = err;
    window.dispatchEvent(e);
    if (!e.defaultPrevented) {
      throw err;
    }
  }
  return promise.then((res) => {
    for (const item of res || []) {
      if (item.status !== "rejected") continue;
      handlePreloadError(item.reason);
    }
    return baseModule().catch(handlePreloadError);
  });
};
function ssProductRecommendations(section) {
  var _a2, _b, _c;
  const profileTag = (_a2 = section == null ? void 0 : section.dataset) == null ? void 0 : _a2.ssProfileTag;
  const productID = (_b = section == null ? void 0 : section.dataset) == null ? void 0 : _b.productId;
  const isCartPage = !!document.querySelector("#cartPage");
  const $csID = (_c = document.querySelector("#cartPage")) == null ? void 0 : _c.dataset.csId;
  const recommendationLimit = 4;
  function getRecommendedProducts() {
    return new Promise((resolve, reject) => {
      let ssURL = `https://${SDG.Data.ssId}.a.searchspring.io/boost/${SDG.Data.ssId}/recommend?tags=${profileTag}&limits=${recommendationLimit}`;
      if (productID) {
        ssURL += `&product=${productID}`;
      }
      if (isCartPage) {
        if ($csID) {
          ssURL += `&shopper=${$csID}`;
        }
        const cartItems = document.querySelectorAll(".cart__item");
        if (cartItems.length) {
          const itemIds = Array.from(cartItems).map((item) => item.dataset.itemProductId).join(",");
          ssURL += `&cart=${itemIds}`;
        }
      }
      console.log(`ssURL: ${ssURL}`);
      fetch(ssURL).then((res) => res.json()).then((data) => {
        const ssData = data[0].results;
        if (ssData.length) {
          const handles = ssData.map((result) => result.attributes.handle);
          resolve(handles);
        } else {
          resolve([]);
        }
      }).catch((error) => {
        console.warn("Error fetching SearchSpring product recommendations:", { error });
        reject(error);
      });
    });
  }
  return getRecommendedProducts();
}
window.productSwatchCache = window.productSwatchCache || {};
window.productSwatchInFlight = window.productSwatchInFlight || {};
function initProductRecommendations({
  selector,
  view = "get-product-card",
  cardClasses = [],
  observe = false,
  observer: observer2 = null
} = {}) {
  const $section = document.querySelector(selector);
  const FeaturedProducts = $section == null ? void 0 : $section.closest(".redesign-feature-products");
  if ($section) {
    ssProductRecommendations($section).then((handles) => {
      if (!handles || handles.length === 0) {
        FeaturedProducts == null ? void 0 : FeaturedProducts.classList.add("hidden");
        return;
      }
      FeaturedProducts == null ? void 0 : FeaturedProducts.classList.remove("hidden");
      renderProductCardsFromHandles(handles, $section, {
        view,
        cardClasses
      });
    }).catch((err) => {
      console.warn("Error getting handles from ssProductRecommendations:", err);
      FeaturedProducts == null ? void 0 : FeaturedProducts.classList.add("hidden");
    });
  } else {
    initProductCardSwatchListeners();
    if (observe && observer2) {
      document.querySelectorAll(".product-card-wrapper").forEach((el) => {
        observer2.observe(el);
      });
    }
  }
}
document.addEventListener("DOMContentLoaded", () => {
  const $sectionNeedsSSProductRecs = document.querySelector(".js-load-ss-recs");
  const FeaturedProducts = $sectionNeedsSSProductRecs == null ? void 0 : $sectionNeedsSSProductRecs.closest(".redesign-feature-products");
  if ($sectionNeedsSSProductRecs) {
    ssProductRecommendations($sectionNeedsSSProductRecs).then((handles) => {
      if (!handles || handles.length === 0) {
        FeaturedProducts == null ? void 0 : FeaturedProducts.classList.add("hidden");
        return;
      }
      FeaturedProducts == null ? void 0 : FeaturedProducts.classList.remove("hidden");
      renderProductCardsFromHandles(handles, $sectionNeedsSSProductRecs, {
        view: "get-product-card",
        cardClasses: ["basis-[calc(50%-4px)]", "lg:basis-1/4"]
      });
    }).catch((err) => {
      console.warn("thereError getting handles from ssProductRecommendations:", err);
      FeaturedProducts == null ? void 0 : FeaturedProducts.classList.add("hidden");
    });
  } else {
    initProductCardSwatchListeners();
    document.querySelectorAll(".product-card-wrapper").forEach((el) => {
      observer.observe(el);
    });
  }
});
if (_JK.config.template === "cart") {
  ["jkCart:removed-item", "jkCart:added-item"].forEach((eventType) => {
    window.addEventListener(eventType, () => {
      setTimeout(() => {
        initProductRecommendations({
          selector: ".js-load-ss-recs",
          view: "get-product-card",
          cardClasses: ["basis-[calc(50%-4px)]", "lg:basis-1/4"],
          observe: true,
          observer: window == null ? void 0 : window.observer
        });
      }, 800);
    });
  });
}
const observer = new IntersectionObserver((entries, obs) => {
  entries.forEach((entry) => {
    if (!entry.isIntersecting) return;
    const el = entry.target;
    const swatches = el.querySelectorAll(".js-swap-product");
    const tasks = Array.from(swatches).map(async (swatch) => {
      var _a2;
      const jsonResource = swatch.dataset.handlejs;
      if (!jsonResource || window.productSwatchCache[jsonResource] || window.productSwatchInFlight[jsonResource]) return;
      try {
        const res = await fetch(jsonResource);
        if (!res.ok) {
          if (res.status === 404) {
            window.productSwatchCache[jsonResource] = "404";
            (_a2 = swatch.parentElement) == null ? void 0 : _a2.remove();
            document.querySelectorAll(`.js-swap-product[data-handlejs="${jsonResource}"]`).forEach((otherSwatch) => {
              var _a3;
              (_a3 = otherSwatch.parentElement) == null ? void 0 : _a3.remove();
            });
            return;
          }
          console.warn(`Swatch preload failed with status ${res.status}`);
          return;
        }
        const html = await res.text();
        window.productSwatchCache[jsonResource] = html;
        const { markSoldOutFromHTML, preloadImagesFromHTML } = await __vitePreload(async () => {
          const { markSoldOutFromHTML: markSoldOutFromHTML2, preloadImagesFromHTML: preloadImagesFromHTML2 } = await import("./sticky-header-B-J49vFi.js").then((n) => n.u);
          return { markSoldOutFromHTML: markSoldOutFromHTML2, preloadImagesFromHTML: preloadImagesFromHTML2 };
        }, true ? [] : void 0, import.meta.url);
        markSoldOutFromHTML(html, swatch);
        preloadImagesFromHTML(html);
      } catch (err) {
        console.warn("Unexpected preload error:", err);
      } finally {
        delete window.productSwatchInFlight[jsonResource];
      }
    });
    Promise.all(tasks).then(() => {
      applyMoreColorsIndicator(el);
    });
    obs.unobserve(el);
  });
}, {
  rootMargin: "0px",
  threshold: 0.1
});
const screenPercentage = 0.4;
const $scrollToTop = document.querySelector(".js-scrollToTop");
if ($scrollToTop) {
  const debouncedScroll = debounce(handleScroll, 250);
  window.addEventListener("scroll", debouncedScroll);
  $scrollToTop.addEventListener("click", doScrollToTop);
}
function doScrollToTop() {
  window.scrollTo({ top: 0, behavior: "smooth" });
}
function handleScroll() {
  const pageH = document.documentElement.scrollHeight;
  const threshold = pageH * screenPercentage;
  const currLoc = window.pageYOffset;
  if (currLoc >= threshold) {
    $scrollToTop.classList.remove("hidden");
    $scrollToTop.setAttribute("aria-hidden", "false");
    return;
  }
  $scrollToTop.classList.add("hidden");
  $scrollToTop.setAttribute("aria-hidden", "true");
}
const $playButtons = document.querySelectorAll(".js-section-video-play-btn");
const $pauseButtons = document.querySelectorAll(".js-section-video-pause-btn");
$playButtons.forEach(($btn) => {
  $btn.addEventListener("click", (e) => {
    e.stopPropagation();
    const button = e.target.closest("button");
    const [$desktopVideo, $mobileVideo, $playBtn, $pauseBtn] = getControlsElements(button.getAttribute("data-section-id"));
    playVideo($desktopVideo, $mobileVideo, $playBtn, $pauseBtn);
  });
});
$pauseButtons.forEach(($btn) => {
  $btn.addEventListener("click", (e) => {
    e.stopPropagation();
    const button = e.target.closest("button");
    const [$desktopVideo, $mobileVideo, $playBtn, $pauseBtn] = getControlsElements(button.getAttribute("data-section-id"));
    pauseVideo($desktopVideo, $mobileVideo, $playBtn, $pauseBtn);
  });
});
function getControlsElements(sectionId) {
  const desktopVideoId = `${sectionId}-desktop-video`;
  const mobileVideoId = `${sectionId}-mobile-video`;
  const playBtnId = `${sectionId}-play-btn`;
  const pauseBtnId = `${sectionId}-pause-btn`;
  const $section = document.getElementById(`shopify-section-${sectionId}`);
  const $desktopVideo = $section.querySelector(`#${desktopVideoId}`);
  const $mobileVideo = $section.querySelector(`#${mobileVideoId}`);
  const $playBtn = $section.querySelector(`#${playBtnId}`);
  const $pauseBtn = $section.querySelector(`#${pauseBtnId}`);
  return [$desktopVideo, $mobileVideo, $playBtn, $pauseBtn];
}
function playVideo($desktopVideo, $mobileVideo, $playBtn, $pauseBtn) {
  $desktopVideo.play();
  $mobileVideo.play();
  $playBtn.classList.add("hidden");
  $pauseBtn.classList.remove("hidden");
}
function pauseVideo($desktopVideo, $mobileVideo, $playBtn, $pauseBtn) {
  $desktopVideo.pause();
  $mobileVideo.pause();
  $playBtn.classList.remove("hidden");
  $pauseBtn.classList.add("hidden");
}
const defaultSearchSpringProfileTag = "cross-sell";
const maxProducts = 2;
function completeTheLookSearchSpring(productId, profileTag) {
  function getRecommendedProducts() {
    const ctlContainer = document.getElementById("pdp-complete-the-look");
    if (!profileTag) {
      profileTag = defaultSearchSpringProfileTag;
    }
    const ssURL = `https://${SDG.Data.ssId}.a.searchspring.io/boost/${SDG.Data.ssId}/recommend?tags=${profileTag}&product=${productId}&limits=${maxProducts}`;
    fetch(ssURL).then((res) => res.json()).then((data) => {
      const ssData = data[0].results;
      if (ssData.length) {
        ssData.forEach((item) => {
          if (item.attributes.images.length >= 1) {
            let img1 = item.attributes.images[0];
            img1 = img1.replace(/\.(?=[^.]*$)/, "_504x600.");
            const $card = document.createElement("div");
            $card.classList.add("basis-1/2");
            $card.innerHTML = `
                <a href="${item.mappings.core.url}">
                  <div class="">
                    <img class="lazyload" data-src="${img1}" alt="${item.mappings.core.name} Featured Image" data-handle="${item.attributes.handle}">
                  </div>
                  <div class="mt-12">
                    <h3 class="redesign-body-6 text-charcoal-100" data-handle="${item.attributes.handle}">${item.mappings.core.name}</h3>
                  </div>
                </a>
              `;
            ctlContainer.appendChild($card);
          }
        });
      }
    }).catch((error) => {
      console.warn("Error fetching SearchSpring Complete The Look product data:", { error });
    });
    return ctlContainer;
  }
  function init() {
    getRecommendedProducts();
  }
  return init();
}
function productStars() {
  document.addEventListener("DOMContentLoaded", () => {
    const reviewsBtn = document.getElementById("pdp-reviews-cta");
    const totalReviews = reviewsBtn == null ? void 0 : reviewsBtn.querySelector(".js-yotpo-reviews");
    const widgetInstance = reviewsBtn == null ? void 0 : reviewsBtn.querySelector(".yotpo-widget-instance");
    const productId = widgetInstance == null ? void 0 : widgetInstance.getAttribute("data-yotpo-product-id");
    const reviewsSection = document.querySelector("section.reviews-section");
    if (!reviewsBtn || !totalReviews || !widgetInstance || !productId) return;
    const appKey = totalReviews.getAttribute("data-yotpo-app-key");
    if (!appKey) return;
    fetch(`https://api-cdn.yotpo.com/products/${appKey}/${productId}/bottomline`).then((response) => {
      if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
      }
      return response.json();
    }).then((data) => {
      var _a2, _b;
      const reviewsCount = ((_b = (_a2 = data == null ? void 0 : data.response) == null ? void 0 : _a2.bottomline) == null ? void 0 : _b.total_reviews) || 0;
      if (reviewsCount > 0) {
        totalReviews.innerText = `(${reviewsCount})`;
        reviewsBtn.classList.remove("hidden");
        reviewsSection == null ? void 0 : reviewsSection.classList.remove("hidden");
      }
    }).catch((error) => {
      console.error("Yotpo fetch error:", error);
    });
  });
}
function productSizeChart($productSection) {
  const btn_sizeChartModal = $productSection.querySelector(".js-open-modal-size-chart");
  if (btn_sizeChartModal) {
    new UniversalModal(".modal-pdp-size-chart", ".js-open-modal-size-chart", "#close-sizeChart-modal");
  }
  const term = "Furniture Size Chart";
  const matchPattern = `[[${term}]]`;
  const accMenus = $productSection.querySelectorAll(".js-acc-menu");
  accMenus.forEach((menu) => {
    const descendants = menu.querySelectorAll("*");
    descendants.forEach((el) => {
      if (el.childNodes && el.childNodes.length) {
        el.childNodes.forEach((node) => {
          if (node.nodeType === Node.TEXT_NODE && node.nodeValue.includes(matchPattern)) {
            const linkHTML = createLinkFromTemplate("gt-light-12-dark-line-grow", {
              text: term,
              url: "#",
              additionalClasses: "js-open-modal-size-chart"
            });
            const wrapper = document.createElement("span");
            wrapper.innerHTML = node.nodeValue.replace(matchPattern, linkHTML);
            el.replaceChild(wrapper, node);
            new UniversalModal(".modal-pdp-size-chart", ".js-open-modal-size-chart", "#close-sizeChart-modal");
          }
        });
      }
    });
  });
}
function productDimensionsChart($productSection) {
  const btn_productDimensionsChart = $productSection.querySelector(".js-open-modal-product-dimensions");
  if (btn_productDimensionsChart) {
    new UniversalModal(".modal-pdp-product-dimensions-chart", ".js-open-modal-product-dimensions", "#close-productDimensionsChart-modal");
  }
}
class DisplayRecentlyViewed {
  constructor() {
    this.container = document.querySelector(".js-load-recently-viewed");
  }
  init() {
    const minItems = 1;
    const maxToShow = 4;
    if (!this.container) return;
    const rvHandlesString = this.getRecentlyViewedProducts("handles");
    if (!rvHandlesString) {
      _JK.helpers.addClass(this.container.parentElement, "hidden");
      return;
    }
    let handles = rvHandlesString.split(",");
    const currentProductHandle = window.location.pathname.split("/").pop();
    handles = handles.filter((handle) => handle !== currentProductHandle);
    if (handles.length < minItems) {
      this.container.parentElement.classList.add("hidden");
      return;
    }
    const handlesToRender = handles.slice(0, maxToShow);
    renderProductCardsFromHandles(handlesToRender, this.container, {
      view: "get-product-card",
      cardClasses: ["basis-[calc(50%-4px)]", "lg:basis-1/4"]
    });
  }
  getRecentlyViewedProducts(type) {
    const productData = JSON.parse(localStorage.getItem("recently-viewed"));
    if (!productData || productData.length === 0) return "";
    const ids = productData.map((item) => item.id).reverse().join(",");
    const handles = productData.map((item) => item.handle).reverse().join(",");
    return type === "handles" ? handles : ids;
  }
}
function productDescriptionFormatter() {
  var _a2;
  const panel = document.getElementById("acc-panel-1");
  const itemTitle = (_a2 = document.querySelector(".js-title")) == null ? void 0 : _a2.textContent.trim();
  for (let child of panel.childNodes) {
    if (child.nodeType === Node.ELEMENT_NODE || child.nodeType === Node.TEXT_NODE) {
      const text = child.textContent.trim();
      if (text.startsWith(itemTitle)) {
        if (child.nodeType === Node.ELEMENT_NODE) {
          child.classList.add("hidden");
        } else {
          const span = document.createElement("span");
          span.className = "hidden";
          span.textContent = text;
          panel.replaceChild(span, child);
        }
        break;
      }
    }
  }
}
try {
  const ShopifyTemplate = ((_a = _JK == null ? void 0 : _JK.config) == null ? void 0 : _a.template) || "";
  const isProductPage = ShopifyTemplate.includes("product");
  const accordionEl = document.getElementById("product-details-accordion");
  if (accordionEl) {
    const accordion = SDG.accordion({
      dom: {
        btn: "js-acc-btn",
        id: "product-details-accordion",
        menu: "js-acc-menu"
      },
      type: "toggle"
    });
    accordion.init();
    const descPanel = accordionEl.querySelector("#acc-panel-1");
    if (descPanel.getAttribute("data-reformat-description") === "true") {
      productDescriptionFormatter();
    }
  }
  const $productForm = document.getElementById("addToBagForm");
  const $productSection = document.getElementById("product");
  if ($productForm && $productSection) {
    if (isProductPage) {
      initAddToBag(cart);
    }
    const productConfigurables = new ProductConfigurables({
      productForm: $productForm,
      productSection: $productSection
    });
    productConfigurables.init();
    productDimensionsChart($productSection);
    productSizeChart($productSection);
    productQty(document, $productForm);
  } else {
    console.warn("[product.js] Product form or section not found. Skipping configurable initialization.");
  }
  const mainGallery = document.querySelector("#gallery-carousel");
  const thumbsGallery = document.querySelector("#gallery-thumbs");
  if (mainGallery && thumbsGallery) {
    new ProductGallery("#gallery-carousel", "#gallery-thumbs");
  }
  const ctl = document.getElementById("pdp-complete-the-look");
  if (ctl && ctl.dataset.ctlSource === "SearchSpring") {
    completeTheLookSearchSpring(ctl.dataset.ctlProductId, ctl.dataset.ctlProfiletag);
  }
  document.addEventListener("DOMContentLoaded", () => {
    productSwatches();
  });
  productStars();
  const recentlyViewed = new DisplayRecentlyViewed();
  recentlyViewed.init();
} catch (err) {
  console.error("[product.js] Unexpected error initializing product page components:", err);
}
document.addEventListener("DOMContentLoaded", () => {
  const promoCarousels = document.querySelectorAll(".splide.tile-carousel");
  promoCarousels.forEach((carouselEl) => {
    try {
      const defaultConfig = {
        type: "loop",
        perPage: 1,
        arrows: false,
        pagination: false,
        mediaQuery: "min",
        autoWidth: true,
        breakpoints: {
          1025: {
            destroy: true
          }
        }
      };
      let customConfig = {};
      const dataSplide = carouselEl.getAttribute("data-splide");
      if (dataSplide) {
        try {
          customConfig = JSON.parse(dataSplide);
        } catch (e) {
          console.warn("Invalid JSON in data-splide:", e);
        }
      }
      const config = { ...defaultConfig, ...customConfig };
      const splide = new Splide(carouselEl, config);
      splide.mount();
    } catch (error) {
      console.error("Failed to initialize Splide carousel:", error);
    }
  });
});
var lazysizes = { exports: {} };
var hasRequiredLazysizes;
function requireLazysizes() {
  if (hasRequiredLazysizes) return lazysizes.exports;
  hasRequiredLazysizes = 1;
  (function(module) {
    (function(window2, factory) {
      var lazySizes = factory(window2, window2.document, Date);
      window2.lazySizes = lazySizes;
      if (module.exports) {
        module.exports = lazySizes;
      }
    })(
      typeof window != "undefined" ? window : {},
      /**
       * import("./types/global")
       * @typedef { import("./types/lazysizes-config").LazySizesConfigPartial } LazySizesConfigPartial
       */
      function l(window2, document2, Date2) {
        var lazysizes2, lazySizesCfg;
        (function() {
          var prop;
          var lazySizesDefaults = {
            lazyClass: "lazyload",
            loadedClass: "lazyloaded",
            loadingClass: "lazyloading",
            preloadClass: "lazypreload",
            errorClass: "lazyerror",
            //strictClass: 'lazystrict',
            autosizesClass: "lazyautosizes",
            fastLoadedClass: "ls-is-cached",
            iframeLoadMode: 0,
            srcAttr: "data-src",
            srcsetAttr: "data-srcset",
            sizesAttr: "data-sizes",
            //preloadAfterLoad: false,
            minSize: 40,
            customMedia: {},
            init: true,
            expFactor: 1.5,
            hFac: 0.8,
            loadMode: 2,
            loadHidden: true,
            ricTimeout: 0,
            throttleDelay: 125
          };
          lazySizesCfg = window2.lazySizesConfig || window2.lazysizesConfig || {};
          for (prop in lazySizesDefaults) {
            if (!(prop in lazySizesCfg)) {
              lazySizesCfg[prop] = lazySizesDefaults[prop];
            }
          }
        })();
        if (!document2 || !document2.getElementsByClassName) {
          return {
            init: function() {
            },
            /**
             * @type { LazySizesConfigPartial }
             */
            cfg: lazySizesCfg,
            /**
             * @type { true }
             */
            noSupport: true
          };
        }
        var docElem = document2.documentElement;
        var supportPicture = window2.HTMLPictureElement;
        var _addEventListener = "addEventListener";
        var _getAttribute = "getAttribute";
        var addEventListener2 = window2[_addEventListener].bind(window2);
        var setTimeout2 = window2.setTimeout;
        var requestAnimationFrame = window2.requestAnimationFrame || setTimeout2;
        var requestIdleCallback = window2.requestIdleCallback;
        var regPicture = /^picture$/i;
        var loadEvents = ["load", "error", "lazyincluded", "_lazyloaded"];
        var regClassCache = {};
        var forEach = Array.prototype.forEach;
        var hasClass = function(ele, cls) {
          if (!regClassCache[cls]) {
            regClassCache[cls] = new RegExp("(\\s|^)" + cls + "(\\s|$)");
          }
          return regClassCache[cls].test(ele[_getAttribute]("class") || "") && regClassCache[cls];
        };
        var addClass = function(ele, cls) {
          if (!hasClass(ele, cls)) {
            ele.setAttribute("class", (ele[_getAttribute]("class") || "").trim() + " " + cls);
          }
        };
        var removeClass = function(ele, cls) {
          var reg;
          if (reg = hasClass(ele, cls)) {
            ele.setAttribute("class", (ele[_getAttribute]("class") || "").replace(reg, " "));
          }
        };
        var addRemoveLoadEvents = function(dom, fn, add) {
          var action = add ? _addEventListener : "removeEventListener";
          if (add) {
            addRemoveLoadEvents(dom, fn);
          }
          loadEvents.forEach(function(evt) {
            dom[action](evt, fn);
          });
        };
        var triggerEvent = function(elem, name, detail, noBubbles, noCancelable) {
          var event = document2.createEvent("Event");
          if (!detail) {
            detail = {};
          }
          detail.instance = lazysizes2;
          event.initEvent(name, !noBubbles, !noCancelable);
          event.detail = detail;
          elem.dispatchEvent(event);
          return event;
        };
        var updatePolyfill = function(el, full) {
          var polyfill;
          if (!supportPicture && (polyfill = window2.picturefill || lazySizesCfg.pf)) {
            if (full && full.src && !el[_getAttribute]("srcset")) {
              el.setAttribute("srcset", full.src);
            }
            polyfill({ reevaluate: true, elements: [el] });
          } else if (full && full.src) {
            el.src = full.src;
          }
        };
        var getCSS = function(elem, style) {
          return (getComputedStyle(elem, null) || {})[style];
        };
        var getWidth = function(elem, parent, width) {
          width = width || elem.offsetWidth;
          while (width < lazySizesCfg.minSize && parent && !elem._lazysizesWidth) {
            width = parent.offsetWidth;
            parent = parent.parentNode;
          }
          return width;
        };
        var rAF = function() {
          var running, waiting;
          var firstFns = [];
          var secondFns = [];
          var fns = firstFns;
          var run = function() {
            var runFns = fns;
            fns = firstFns.length ? secondFns : firstFns;
            running = true;
            waiting = false;
            while (runFns.length) {
              runFns.shift()();
            }
            running = false;
          };
          var rafBatch = function(fn, queue) {
            if (running && !queue) {
              fn.apply(this, arguments);
            } else {
              fns.push(fn);
              if (!waiting) {
                waiting = true;
                (document2.hidden ? setTimeout2 : requestAnimationFrame)(run);
              }
            }
          };
          rafBatch._lsFlush = run;
          return rafBatch;
        }();
        var rAFIt = function(fn, simple) {
          return simple ? function() {
            rAF(fn);
          } : function() {
            var that = this;
            var args = arguments;
            rAF(function() {
              fn.apply(that, args);
            });
          };
        };
        var throttle = function(fn) {
          var running;
          var lastTime = 0;
          var gDelay = lazySizesCfg.throttleDelay;
          var rICTimeout = lazySizesCfg.ricTimeout;
          var run = function() {
            running = false;
            lastTime = Date2.now();
            fn();
          };
          var idleCallback = requestIdleCallback && rICTimeout > 49 ? function() {
            requestIdleCallback(run, { timeout: rICTimeout });
            if (rICTimeout !== lazySizesCfg.ricTimeout) {
              rICTimeout = lazySizesCfg.ricTimeout;
            }
          } : rAFIt(function() {
            setTimeout2(run);
          }, true);
          return function(isPriority) {
            var delay;
            if (isPriority = isPriority === true) {
              rICTimeout = 33;
            }
            if (running) {
              return;
            }
            running = true;
            delay = gDelay - (Date2.now() - lastTime);
            if (delay < 0) {
              delay = 0;
            }
            if (isPriority || delay < 9) {
              idleCallback();
            } else {
              setTimeout2(idleCallback, delay);
            }
          };
        };
        var debounce2 = function(func) {
          var timeout, timestamp;
          var wait = 99;
          var run = function() {
            timeout = null;
            func();
          };
          var later = function() {
            var last = Date2.now() - timestamp;
            if (last < wait) {
              setTimeout2(later, wait - last);
            } else {
              (requestIdleCallback || run)(run);
            }
          };
          return function() {
            timestamp = Date2.now();
            if (!timeout) {
              timeout = setTimeout2(later, wait);
            }
          };
        };
        var loader = function() {
          var preloadElems, isCompleted, resetPreloadingTimer, loadMode, started;
          var eLvW, elvH, eLtop, eLleft, eLright, eLbottom, isBodyHidden;
          var regImg = /^img$/i;
          var regIframe = /^iframe$/i;
          var supportScroll = "onscroll" in window2 && !/(gle|ing)bot/.test(navigator.userAgent);
          var shrinkExpand = 0;
          var currentExpand = 0;
          var isLoading = 0;
          var lowRuns = -1;
          var resetPreloading = function(e) {
            isLoading--;
            if (!e || isLoading < 0 || !e.target) {
              isLoading = 0;
            }
          };
          var isVisible = function(elem) {
            if (isBodyHidden == null) {
              isBodyHidden = getCSS(document2.body, "visibility") == "hidden";
            }
            return isBodyHidden || !(getCSS(elem.parentNode, "visibility") == "hidden" && getCSS(elem, "visibility") == "hidden");
          };
          var isNestedVisible = function(elem, elemExpand) {
            var outerRect;
            var parent = elem;
            var visible = isVisible(elem);
            eLtop -= elemExpand;
            eLbottom += elemExpand;
            eLleft -= elemExpand;
            eLright += elemExpand;
            while (visible && (parent = parent.offsetParent) && parent != document2.body && parent != docElem) {
              visible = (getCSS(parent, "opacity") || 1) > 0;
              if (visible && getCSS(parent, "overflow") != "visible") {
                outerRect = parent.getBoundingClientRect();
                visible = eLright > outerRect.left && eLleft < outerRect.right && eLbottom > outerRect.top - 1 && eLtop < outerRect.bottom + 1;
              }
            }
            return visible;
          };
          var checkElements = function() {
            var eLlen, i, rect, autoLoadElem, loadedSomething, elemExpand, elemNegativeExpand, elemExpandVal, beforeExpandVal, defaultExpand, preloadExpand, hFac;
            var lazyloadElems = lazysizes2.elements;
            if ((loadMode = lazySizesCfg.loadMode) && isLoading < 8 && (eLlen = lazyloadElems.length)) {
              i = 0;
              lowRuns++;
              for (; i < eLlen; i++) {
                if (!lazyloadElems[i] || lazyloadElems[i]._lazyRace) {
                  continue;
                }
                if (!supportScroll || lazysizes2.prematureUnveil && lazysizes2.prematureUnveil(lazyloadElems[i])) {
                  unveilElement(lazyloadElems[i]);
                  continue;
                }
                if (!(elemExpandVal = lazyloadElems[i][_getAttribute]("data-expand")) || !(elemExpand = elemExpandVal * 1)) {
                  elemExpand = currentExpand;
                }
                if (!defaultExpand) {
                  defaultExpand = !lazySizesCfg.expand || lazySizesCfg.expand < 1 ? docElem.clientHeight > 500 && docElem.clientWidth > 500 ? 500 : 370 : lazySizesCfg.expand;
                  lazysizes2._defEx = defaultExpand;
                  preloadExpand = defaultExpand * lazySizesCfg.expFactor;
                  hFac = lazySizesCfg.hFac;
                  isBodyHidden = null;
                  if (currentExpand < preloadExpand && isLoading < 1 && lowRuns > 2 && loadMode > 2 && !document2.hidden) {
                    currentExpand = preloadExpand;
                    lowRuns = 0;
                  } else if (loadMode > 1 && lowRuns > 1 && isLoading < 6) {
                    currentExpand = defaultExpand;
                  } else {
                    currentExpand = shrinkExpand;
                  }
                }
                if (beforeExpandVal !== elemExpand) {
                  eLvW = innerWidth + elemExpand * hFac;
                  elvH = innerHeight + elemExpand;
                  elemNegativeExpand = elemExpand * -1;
                  beforeExpandVal = elemExpand;
                }
                rect = lazyloadElems[i].getBoundingClientRect();
                if ((eLbottom = rect.bottom) >= elemNegativeExpand && (eLtop = rect.top) <= elvH && (eLright = rect.right) >= elemNegativeExpand * hFac && (eLleft = rect.left) <= eLvW && (eLbottom || eLright || eLleft || eLtop) && (lazySizesCfg.loadHidden || isVisible(lazyloadElems[i])) && (isCompleted && isLoading < 3 && !elemExpandVal && (loadMode < 3 || lowRuns < 4) || isNestedVisible(lazyloadElems[i], elemExpand))) {
                  unveilElement(lazyloadElems[i]);
                  loadedSomething = true;
                  if (isLoading > 9) {
                    break;
                  }
                } else if (!loadedSomething && isCompleted && !autoLoadElem && isLoading < 4 && lowRuns < 4 && loadMode > 2 && (preloadElems[0] || lazySizesCfg.preloadAfterLoad) && (preloadElems[0] || !elemExpandVal && (eLbottom || eLright || eLleft || eLtop || lazyloadElems[i][_getAttribute](lazySizesCfg.sizesAttr) != "auto"))) {
                  autoLoadElem = preloadElems[0] || lazyloadElems[i];
                }
              }
              if (autoLoadElem && !loadedSomething) {
                unveilElement(autoLoadElem);
              }
            }
          };
          var throttledCheckElements = throttle(checkElements);
          var switchLoadingClass = function(e) {
            var elem = e.target;
            if (elem._lazyCache) {
              delete elem._lazyCache;
              return;
            }
            resetPreloading(e);
            addClass(elem, lazySizesCfg.loadedClass);
            removeClass(elem, lazySizesCfg.loadingClass);
            addRemoveLoadEvents(elem, rafSwitchLoadingClass);
            triggerEvent(elem, "lazyloaded");
          };
          var rafedSwitchLoadingClass = rAFIt(switchLoadingClass);
          var rafSwitchLoadingClass = function(e) {
            rafedSwitchLoadingClass({ target: e.target });
          };
          var changeIframeSrc = function(elem, src) {
            var loadMode2 = elem.getAttribute("data-load-mode") || lazySizesCfg.iframeLoadMode;
            if (loadMode2 == 0) {
              elem.contentWindow.location.replace(src);
            } else if (loadMode2 == 1) {
              elem.src = src;
            }
          };
          var handleSources = function(source) {
            var customMedia;
            var sourceSrcset = source[_getAttribute](lazySizesCfg.srcsetAttr);
            if (customMedia = lazySizesCfg.customMedia[source[_getAttribute]("data-media") || source[_getAttribute]("media")]) {
              source.setAttribute("media", customMedia);
            }
            if (sourceSrcset) {
              source.setAttribute("srcset", sourceSrcset);
            }
          };
          var lazyUnveil = rAFIt(function(elem, detail, isAuto, sizes, isImg) {
            var src, srcset, parent, isPicture, event, firesLoad;
            if (!(event = triggerEvent(elem, "lazybeforeunveil", detail)).defaultPrevented) {
              if (sizes) {
                if (isAuto) {
                  addClass(elem, lazySizesCfg.autosizesClass);
                } else {
                  elem.setAttribute("sizes", sizes);
                }
              }
              srcset = elem[_getAttribute](lazySizesCfg.srcsetAttr);
              src = elem[_getAttribute](lazySizesCfg.srcAttr);
              if (isImg) {
                parent = elem.parentNode;
                isPicture = parent && regPicture.test(parent.nodeName || "");
              }
              firesLoad = detail.firesLoad || "src" in elem && (srcset || src || isPicture);
              event = { target: elem };
              addClass(elem, lazySizesCfg.loadingClass);
              if (firesLoad) {
                clearTimeout(resetPreloadingTimer);
                resetPreloadingTimer = setTimeout2(resetPreloading, 2500);
                addRemoveLoadEvents(elem, rafSwitchLoadingClass, true);
              }
              if (isPicture) {
                forEach.call(parent.getElementsByTagName("source"), handleSources);
              }
              if (srcset) {
                elem.setAttribute("srcset", srcset);
              } else if (src && !isPicture) {
                if (regIframe.test(elem.nodeName)) {
                  changeIframeSrc(elem, src);
                } else {
                  elem.src = src;
                }
              }
              if (isImg && (srcset || isPicture)) {
                updatePolyfill(elem, { src });
              }
            }
            if (elem._lazyRace) {
              delete elem._lazyRace;
            }
            removeClass(elem, lazySizesCfg.lazyClass);
            rAF(function() {
              var isLoaded = elem.complete && elem.naturalWidth > 1;
              if (!firesLoad || isLoaded) {
                if (isLoaded) {
                  addClass(elem, lazySizesCfg.fastLoadedClass);
                }
                switchLoadingClass(event);
                elem._lazyCache = true;
                setTimeout2(function() {
                  if ("_lazyCache" in elem) {
                    delete elem._lazyCache;
                  }
                }, 9);
              }
              if (elem.loading == "lazy") {
                isLoading--;
              }
            }, true);
          });
          var unveilElement = function(elem) {
            if (elem._lazyRace) {
              return;
            }
            var detail;
            var isImg = regImg.test(elem.nodeName);
            var sizes = isImg && (elem[_getAttribute](lazySizesCfg.sizesAttr) || elem[_getAttribute]("sizes"));
            var isAuto = sizes == "auto";
            if ((isAuto || !isCompleted) && isImg && (elem[_getAttribute]("src") || elem.srcset) && !elem.complete && !hasClass(elem, lazySizesCfg.errorClass) && hasClass(elem, lazySizesCfg.lazyClass)) {
              return;
            }
            detail = triggerEvent(elem, "lazyunveilread").detail;
            if (isAuto) {
              autoSizer.updateElem(elem, true, elem.offsetWidth);
            }
            elem._lazyRace = true;
            isLoading++;
            lazyUnveil(elem, detail, isAuto, sizes, isImg);
          };
          var afterScroll = debounce2(function() {
            lazySizesCfg.loadMode = 3;
            throttledCheckElements();
          });
          var altLoadmodeScrollListner = function() {
            if (lazySizesCfg.loadMode == 3) {
              lazySizesCfg.loadMode = 2;
            }
            afterScroll();
          };
          var onload = function() {
            if (isCompleted) {
              return;
            }
            if (Date2.now() - started < 999) {
              setTimeout2(onload, 999);
              return;
            }
            isCompleted = true;
            lazySizesCfg.loadMode = 3;
            throttledCheckElements();
            addEventListener2("scroll", altLoadmodeScrollListner, true);
          };
          return {
            _: function() {
              started = Date2.now();
              lazysizes2.elements = document2.getElementsByClassName(lazySizesCfg.lazyClass);
              preloadElems = document2.getElementsByClassName(lazySizesCfg.lazyClass + " " + lazySizesCfg.preloadClass);
              addEventListener2("scroll", throttledCheckElements, true);
              addEventListener2("resize", throttledCheckElements, true);
              addEventListener2("pageshow", function(e) {
                if (e.persisted) {
                  var loadingElements = document2.querySelectorAll("." + lazySizesCfg.loadingClass);
                  if (loadingElements.length && loadingElements.forEach) {
                    requestAnimationFrame(function() {
                      loadingElements.forEach(function(img) {
                        if (img.complete) {
                          unveilElement(img);
                        }
                      });
                    });
                  }
                }
              });
              if (window2.MutationObserver) {
                new MutationObserver(throttledCheckElements).observe(docElem, { childList: true, subtree: true, attributes: true });
              } else {
                docElem[_addEventListener]("DOMNodeInserted", throttledCheckElements, true);
                docElem[_addEventListener]("DOMAttrModified", throttledCheckElements, true);
                setInterval(throttledCheckElements, 999);
              }
              addEventListener2("hashchange", throttledCheckElements, true);
              ["focus", "mouseover", "click", "load", "transitionend", "animationend"].forEach(function(name) {
                document2[_addEventListener](name, throttledCheckElements, true);
              });
              if (/d$|^c/.test(document2.readyState)) {
                onload();
              } else {
                addEventListener2("load", onload);
                document2[_addEventListener]("DOMContentLoaded", throttledCheckElements);
                setTimeout2(onload, 2e4);
              }
              if (lazysizes2.elements.length) {
                checkElements();
                rAF._lsFlush();
              } else {
                throttledCheckElements();
              }
            },
            checkElems: throttledCheckElements,
            unveil: unveilElement,
            _aLSL: altLoadmodeScrollListner
          };
        }();
        var autoSizer = function() {
          var autosizesElems;
          var sizeElement = rAFIt(function(elem, parent, event, width) {
            var sources, i, len;
            elem._lazysizesWidth = width;
            width += "px";
            elem.setAttribute("sizes", width);
            if (regPicture.test(parent.nodeName || "")) {
              sources = parent.getElementsByTagName("source");
              for (i = 0, len = sources.length; i < len; i++) {
                sources[i].setAttribute("sizes", width);
              }
            }
            if (!event.detail.dataAttr) {
              updatePolyfill(elem, event.detail);
            }
          });
          var getSizeElement = function(elem, dataAttr, width) {
            var event;
            var parent = elem.parentNode;
            if (parent) {
              width = getWidth(elem, parent, width);
              event = triggerEvent(elem, "lazybeforesizes", { width, dataAttr: !!dataAttr });
              if (!event.defaultPrevented) {
                width = event.detail.width;
                if (width && width !== elem._lazysizesWidth) {
                  sizeElement(elem, parent, event, width);
                }
              }
            }
          };
          var updateElementsSizes = function() {
            var i;
            var len = autosizesElems.length;
            if (len) {
              i = 0;
              for (; i < len; i++) {
                getSizeElement(autosizesElems[i]);
              }
            }
          };
          var debouncedUpdateElementsSizes = debounce2(updateElementsSizes);
          return {
            _: function() {
              autosizesElems = document2.getElementsByClassName(lazySizesCfg.autosizesClass);
              addEventListener2("resize", debouncedUpdateElementsSizes);
            },
            checkElems: debouncedUpdateElementsSizes,
            updateElem: getSizeElement
          };
        }();
        var init = function() {
          if (!init.i && document2.getElementsByClassName) {
            init.i = true;
            autoSizer._();
            loader._();
          }
        };
        setTimeout2(function() {
          if (lazySizesCfg.init) {
            init();
          }
        });
        lazysizes2 = {
          /**
           * @type { LazySizesConfigPartial }
           */
          cfg: lazySizesCfg,
          autoSizer,
          loader,
          init,
          uP: updatePolyfill,
          aC: addClass,
          rC: removeClass,
          hC: hasClass,
          fire: triggerEvent,
          gW: getWidth,
          rAF
        };
        return lazysizes2;
      }
    );
  })(lazysizes);
  return lazysizes.exports;
}
requireLazysizes();
var ls_rias = { exports: {} };
(function(module) {
  (function(window2, factory) {
    var globalInstall = function() {
      factory(window2.lazySizes);
      window2.removeEventListener("lazyunveilread", globalInstall, true);
    };
    factory = factory.bind(null, window2, window2.document);
    if (module.exports) {
      factory(requireLazysizes());
    } else if (window2.lazySizes) {
      globalInstall();
    } else {
      window2.addEventListener("lazyunveilread", globalInstall, true);
    }
  })(window, function(window2, document2, lazySizes) {
    var config, riasCfg;
    var lazySizesCfg = lazySizes.cfg;
    var replaceTypes = { string: 1, number: 1 };
    var regNumber = /^\-*\+*\d+\.*\d*$/;
    var regPicture = /^picture$/i;
    var regWidth = /\s*\{\s*width\s*\}\s*/i;
    var regHeight = /\s*\{\s*height\s*\}\s*/i;
    var regPlaceholder = /\s*\{\s*([a-z0-9]+)\s*\}\s*/ig;
    var regObj = /^\[.*\]|\{.*\}$/;
    var regAllowedSizes = /^(?:auto|\d+(px)?)$/;
    var anchor = document2.createElement("a");
    var img = document2.createElement("img");
    var buggySizes = "srcset" in img && !("sizes" in img);
    var supportPicture = !!window2.HTMLPictureElement && !buggySizes;
    (function() {
      var prop;
      var noop = function() {
      };
      var riasDefaults = {
        prefix: "",
        postfix: "",
        srcAttr: "data-src",
        absUrl: false,
        modifyOptions: noop,
        widthmap: {},
        ratio: false,
        traditionalRatio: false,
        aspectratio: false
      };
      config = lazySizes && lazySizes.cfg;
      if (!config.supportsType) {
        config.supportsType = function(type) {
          return !type;
        };
      }
      if (!config.rias) {
        config.rias = {};
      }
      riasCfg = config.rias;
      if (!("widths" in riasCfg)) {
        riasCfg.widths = [];
        (function(widths) {
          var width;
          var i = 0;
          while (!width || width < 3e3) {
            i += 5;
            if (i > 30) {
              i += 1;
            }
            width = 36 * i;
            widths.push(width);
          }
        })(riasCfg.widths);
      }
      for (prop in riasDefaults) {
        if (!(prop in riasCfg)) {
          riasCfg[prop] = riasDefaults[prop];
        }
      }
    })();
    function getElementOptions(elem, src, options) {
      var attr, parent, setOption, prop, opts;
      var elemStyles = window2.getComputedStyle(elem);
      if (!options) {
        parent = elem.parentNode;
        options = {
          isPicture: !!(parent && regPicture.test(parent.nodeName || ""))
        };
      } else {
        opts = {};
        for (prop in options) {
          opts[prop] = options[prop];
        }
        options = opts;
      }
      setOption = function(attr2, run) {
        var attrVal = elem.getAttribute("data-" + attr2);
        if (!attrVal) {
          var styles = elemStyles.getPropertyValue("--ls-" + attr2);
          if (styles) {
            attrVal = styles.trim();
          }
        }
        if (attrVal) {
          if (attrVal == "true") {
            attrVal = true;
          } else if (attrVal == "false") {
            attrVal = false;
          } else if (regNumber.test(attrVal)) {
            attrVal = parseFloat(attrVal);
          } else if (typeof riasCfg[attr2] == "function") {
            attrVal = riasCfg[attr2](elem, attrVal);
          } else if (regObj.test(attrVal)) {
            try {
              attrVal = JSON.parse(attrVal);
            } catch (e) {
            }
          }
          options[attr2] = attrVal;
        } else if (attr2 in riasCfg && typeof riasCfg[attr2] != "function" && !options[attr2]) {
          options[attr2] = riasCfg[attr2];
        } else if (run && typeof riasCfg[attr2] == "function") {
          options[attr2] = riasCfg[attr2](elem, attrVal);
        }
      };
      for (attr in riasCfg) {
        setOption(attr);
      }
      src.replace(regPlaceholder, function(full, match) {
        if (!(match in options)) {
          setOption(match, true);
        }
      });
      return options;
    }
    function replaceUrlProps(url, options) {
      var candidates = [];
      var replaceFn = function(full, match) {
        return replaceTypes[typeof options[match]] ? options[match] : full;
      };
      candidates.srcset = [];
      if (options.absUrl) {
        anchor.setAttribute("href", url);
        url = anchor.href;
      }
      url = ((options.prefix || "") + url + (options.postfix || "")).replace(regPlaceholder, replaceFn);
      options.widths.forEach(function(width) {
        var widthAlias = options.widthmap[width] || width;
        var ratio = options.aspectratio || options.ratio;
        var traditionalRatio = !options.aspectratio && riasCfg.traditionalRatio;
        var candidate = {
          u: url.replace(regWidth, widthAlias).replace(regHeight, ratio ? traditionalRatio ? Math.round(width * ratio) : Math.round(width / ratio) : ""),
          w: width
        };
        candidates.push(candidate);
        candidates.srcset.push(candidate.c = candidate.u + " " + width + "w");
      });
      return candidates;
    }
    function setSrc(src, opts, elem) {
      var elemW = 0;
      var elemH = 0;
      var sizeElement = elem;
      if (!src) {
        return;
      }
      if (opts.ratio === "container") {
        elemW = sizeElement.scrollWidth;
        elemH = sizeElement.scrollHeight;
        while ((!elemW || !elemH) && sizeElement !== document2) {
          sizeElement = sizeElement.parentNode;
          elemW = sizeElement.scrollWidth;
          elemH = sizeElement.scrollHeight;
        }
        if (elemW && elemH) {
          opts.ratio = opts.traditionalRatio ? elemH / elemW : elemW / elemH;
        }
      }
      src = replaceUrlProps(src, opts);
      src.isPicture = opts.isPicture;
      if (buggySizes && elem.nodeName.toUpperCase() == "IMG") {
        elem.removeAttribute(config.srcsetAttr);
      } else {
        elem.setAttribute(config.srcsetAttr, src.srcset.join(", "));
      }
      Object.defineProperty(elem, "_lazyrias", {
        value: src,
        writable: true
      });
    }
    function createAttrObject(elem, src) {
      var opts = getElementOptions(elem, src);
      riasCfg.modifyOptions.call(elem, { target: elem, details: opts, detail: opts });
      lazySizes.fire(elem, "lazyriasmodifyoptions", opts);
      return opts;
    }
    function getSrc(elem) {
      return elem.getAttribute(elem.getAttribute("data-srcattr") || riasCfg.srcAttr) || elem.getAttribute(config.srcsetAttr) || elem.getAttribute(config.srcAttr) || elem.getAttribute("data-pfsrcset") || "";
    }
    addEventListener("lazybeforesizes", function(e) {
      if (e.detail.instance != lazySizes) {
        return;
      }
      var elem, src, elemOpts, sourceOpts, parent, sources, i, len, sourceSrc, sizes, detail, hasPlaceholder, modified, emptyList;
      elem = e.target;
      if (!e.detail.dataAttr || e.defaultPrevented || riasCfg.disabled || !((sizes = elem.getAttribute(config.sizesAttr) || elem.getAttribute("sizes")) && regAllowedSizes.test(sizes))) {
        return;
      }
      src = getSrc(elem);
      elemOpts = createAttrObject(elem, src);
      hasPlaceholder = regWidth.test(elemOpts.prefix) || regWidth.test(elemOpts.postfix);
      if (elemOpts.isPicture && (parent = elem.parentNode)) {
        sources = parent.getElementsByTagName("source");
        for (i = 0, len = sources.length; i < len; i++) {
          if (hasPlaceholder || regWidth.test(sourceSrc = getSrc(sources[i]))) {
            sourceOpts = getElementOptions(sources[i], sourceSrc, elemOpts);
            setSrc(sourceSrc, sourceOpts, sources[i]);
            modified = true;
          }
        }
      }
      if (hasPlaceholder || regWidth.test(src)) {
        setSrc(src, elemOpts, elem);
        modified = true;
      } else if (modified) {
        emptyList = [];
        emptyList.srcset = [];
        emptyList.isPicture = true;
        Object.defineProperty(elem, "_lazyrias", {
          value: emptyList,
          writable: true
        });
      }
      if (modified) {
        if (supportPicture) {
          elem.removeAttribute(config.srcAttr);
        } else if (sizes != "auto") {
          detail = {
            width: parseInt(sizes, 10)
          };
          polyfill({
            target: elem,
            detail
          });
        }
      }
    }, true);
    var polyfill = function() {
      var ascendingSort = function(a, b) {
        return a.w - b.w;
      };
      var reduceCandidate = function(srces) {
        var lowerCandidate, bonusFactor;
        var len = srces.length;
        var candidate = srces[len - 1];
        var i = 0;
        for (i; i < len; i++) {
          candidate = srces[i];
          candidate.d = candidate.w / srces.w;
          if (candidate.d >= srces.d) {
            if (!candidate.cached && (lowerCandidate = srces[i - 1]) && lowerCandidate.d > srces.d - 0.13 * Math.pow(srces.d, 2.2)) {
              bonusFactor = Math.pow(lowerCandidate.d - 0.6, 1.6);
              if (lowerCandidate.cached) {
                lowerCandidate.d += 0.15 * bonusFactor;
              }
              if (lowerCandidate.d + (candidate.d - srces.d) * bonusFactor > srces.d) {
                candidate = lowerCandidate;
              }
            }
            break;
          }
        }
        return candidate;
      };
      var getWSet = function(elem, testPicture) {
        var src;
        if (!elem._lazyrias && lazySizes.pWS && (src = lazySizes.pWS(elem.getAttribute(config.srcsetAttr || ""))).length) {
          Object.defineProperty(elem, "_lazyrias", {
            value: src,
            writable: true
          });
          if (testPicture && elem.parentNode) {
            src.isPicture = elem.parentNode.nodeName.toUpperCase() == "PICTURE";
          }
        }
        return elem._lazyrias;
      };
      var getX = function(elem) {
        var dpr = window2.devicePixelRatio || 1;
        var optimum = lazySizes.getX && lazySizes.getX(elem);
        return Math.min(optimum || dpr, 2.4, dpr);
      };
      var getCandidate = function(elem, width) {
        var sources, i, len, media, srces, src;
        srces = elem._lazyrias;
        if (srces.isPicture && window2.matchMedia) {
          for (i = 0, sources = elem.parentNode.getElementsByTagName("source"), len = sources.length; i < len; i++) {
            if (getWSet(sources[i]) && !sources[i].getAttribute("type") && (!(media = sources[i].getAttribute("media")) || (matchMedia(media) || {}).matches)) {
              srces = sources[i]._lazyrias;
              break;
            }
          }
        }
        if (!srces.w || srces.w < width) {
          srces.w = width;
          srces.d = getX(elem);
          src = reduceCandidate(srces.sort(ascendingSort));
        }
        return src;
      };
      var polyfill2 = function(e) {
        if (e.detail.instance != lazySizes) {
          return;
        }
        var candidate;
        var elem = e.target;
        if (!buggySizes && (window2.respimage || window2.picturefill || lazySizesCfg.pf)) {
          document2.removeEventListener("lazybeforesizes", polyfill2);
          return;
        }
        if (!("_lazyrias" in elem) && (!e.detail.dataAttr || !getWSet(elem, true))) {
          return;
        }
        candidate = getCandidate(elem, e.detail.width);
        if (candidate && candidate.u && elem._lazyrias.cur != candidate.u) {
          elem._lazyrias.cur = candidate.u;
          candidate.cached = true;
          lazySizes.rAF(function() {
            elem.setAttribute(config.srcAttr, candidate.u);
            elem.setAttribute("src", candidate.u);
          });
        }
      };
      if (!supportPicture) {
        addEventListener("lazybeforesizes", polyfill2);
      } else {
        polyfill2 = function() {
        };
      }
      return polyfill2;
    }();
  });
})(ls_rias);
var ls_respimg = { exports: {} };
(function(module) {
  (function(window2, factory) {
    if (!window2) {
      return;
    }
    var globalInstall = function() {
      factory(window2.lazySizes);
      window2.removeEventListener("lazyunveilread", globalInstall, true);
    };
    factory = factory.bind(null, window2, window2.document);
    if (module.exports) {
      factory(requireLazysizes());
    } else if (window2.lazySizes) {
      globalInstall();
    } else {
      window2.addEventListener("lazyunveilread", globalInstall, true);
    }
  })(typeof window != "undefined" ? window : 0, function(window2, document2, lazySizes) {
    var polyfill;
    var lazySizesCfg = lazySizes.cfg;
    var img = document2.createElement("img");
    var supportSrcset = "sizes" in img && "srcset" in img;
    var regHDesc = /\s+\d+h/g;
    var fixEdgeHDescriptor = function() {
      var regDescriptors = /\s+(\d+)(w|h)\s+(\d+)(w|h)/;
      var forEach = Array.prototype.forEach;
      return function() {
        var img2 = document2.createElement("img");
        var removeHDescriptors = function(source) {
          var ratio, match;
          var srcset = source.getAttribute(lazySizesCfg.srcsetAttr);
          if (srcset) {
            if (match = srcset.match(regDescriptors)) {
              if (match[2] == "w") {
                ratio = match[1] / match[3];
              } else {
                ratio = match[3] / match[1];
              }
              if (ratio) {
                source.setAttribute("data-aspectratio", ratio);
              }
              source.setAttribute(lazySizesCfg.srcsetAttr, srcset.replace(regHDesc, ""));
            }
          }
        };
        var handler = function(e) {
          if (e.detail.instance != lazySizes) {
            return;
          }
          var picture = e.target.parentNode;
          if (picture && picture.nodeName == "PICTURE") {
            forEach.call(picture.getElementsByTagName("source"), removeHDescriptors);
          }
          removeHDescriptors(e.target);
        };
        var test = function() {
          if (!!img2.currentSrc) {
            document2.removeEventListener("lazybeforeunveil", handler);
          }
        };
        document2.addEventListener("lazybeforeunveil", handler);
        img2.onload = test;
        img2.onerror = test;
        img2.srcset = "data:,a 1w 1h";
        if (img2.complete) {
          test();
        }
      };
    }();
    if (!lazySizesCfg.supportsType) {
      lazySizesCfg.supportsType = function(type) {
        return !type;
      };
    }
    if (window2.HTMLPictureElement && supportSrcset) {
      if (!lazySizes.hasHDescriptorFix && document2.msElementsFromPoint) {
        lazySizes.hasHDescriptorFix = true;
        fixEdgeHDescriptor();
      }
      return;
    }
    if (window2.picturefill || lazySizesCfg.pf) {
      return;
    }
    lazySizesCfg.pf = function(options) {
      var i, len;
      if (window2.picturefill) {
        return;
      }
      for (i = 0, len = options.elements.length; i < len; i++) {
        polyfill(options.elements[i]);
      }
    };
    polyfill = function() {
      var ascendingSort = function(a, b) {
        return a.w - b.w;
      };
      var regPxLength = /^\s*\d+\.*\d*px\s*$/;
      var reduceCandidate = function(srces) {
        var lowerCandidate, bonusFactor;
        var len = srces.length;
        var candidate = srces[len - 1];
        var i = 0;
        for (i; i < len; i++) {
          candidate = srces[i];
          candidate.d = candidate.w / srces.w;
          if (candidate.d >= srces.d) {
            if (!candidate.cached && (lowerCandidate = srces[i - 1]) && lowerCandidate.d > srces.d - 0.13 * Math.pow(srces.d, 2.2)) {
              bonusFactor = Math.pow(lowerCandidate.d - 0.6, 1.6);
              if (lowerCandidate.cached) {
                lowerCandidate.d += 0.15 * bonusFactor;
              }
              if (lowerCandidate.d + (candidate.d - srces.d) * bonusFactor > srces.d) {
                candidate = lowerCandidate;
              }
            }
            break;
          }
        }
        return candidate;
      };
      var parseWsrcset = /* @__PURE__ */ function() {
        var candidates;
        var regWCandidates = /(([^,\s].[^\s]+)\s+(\d+)w)/g;
        var regMultiple = /\s/;
        var addCandidate = function(match, candidate, url, wDescriptor) {
          candidates.push({
            c: candidate,
            u: url,
            w: wDescriptor * 1
          });
        };
        return function(input) {
          candidates = [];
          input = input.trim();
          input.replace(regHDesc, "").replace(regWCandidates, addCandidate);
          if (!candidates.length && input && !regMultiple.test(input)) {
            candidates.push({
              c: input,
              u: input,
              w: 99
            });
          }
          return candidates;
        };
      }();
      var runMatchMedia = function() {
        if (runMatchMedia.init) {
          return;
        }
        runMatchMedia.init = true;
        addEventListener("resize", function() {
          var timer;
          var matchMediaElems = document2.getElementsByClassName("lazymatchmedia");
          var run = function() {
            var i, len;
            for (i = 0, len = matchMediaElems.length; i < len; i++) {
              polyfill(matchMediaElems[i]);
            }
          };
          return function() {
            clearTimeout(timer);
            timer = setTimeout(run, 66);
          };
        }());
      };
      var createSrcset = function(elem, isImage) {
        var parsedSet;
        var srcSet = elem.getAttribute("srcset") || elem.getAttribute(lazySizesCfg.srcsetAttr);
        if (!srcSet && isImage) {
          srcSet = !elem._lazypolyfill ? elem.getAttribute(lazySizesCfg.srcAttr) || elem.getAttribute("src") : elem._lazypolyfill._set;
        }
        if (!elem._lazypolyfill || elem._lazypolyfill._set != srcSet) {
          parsedSet = parseWsrcset(srcSet || "");
          if (isImage && elem.parentNode) {
            parsedSet.isPicture = elem.parentNode.nodeName.toUpperCase() == "PICTURE";
            if (parsedSet.isPicture) {
              if (window2.matchMedia) {
                lazySizes.aC(elem, "lazymatchmedia");
                runMatchMedia();
              }
            }
          }
          parsedSet._set = srcSet;
          Object.defineProperty(elem, "_lazypolyfill", {
            value: parsedSet,
            writable: true
          });
        }
      };
      var getX = function(elem) {
        var dpr = window2.devicePixelRatio || 1;
        var optimum = lazySizes.getX && lazySizes.getX(elem);
        return Math.min(optimum || dpr, 2.5, dpr);
      };
      var matchesMedia = function(media) {
        if (window2.matchMedia) {
          matchesMedia = function(media2) {
            return !media2 || (matchMedia(media2) || {}).matches;
          };
        } else {
          return !media;
        }
        return matchesMedia(media);
      };
      var getCandidate = function(elem) {
        var sources, i, len, source, srces, src, width;
        source = elem;
        createSrcset(source, true);
        srces = source._lazypolyfill;
        if (srces.isPicture) {
          for (i = 0, sources = elem.parentNode.getElementsByTagName("source"), len = sources.length; i < len; i++) {
            if (lazySizesCfg.supportsType(sources[i].getAttribute("type"), elem) && matchesMedia(sources[i].getAttribute("media"))) {
              source = sources[i];
              createSrcset(source);
              srces = source._lazypolyfill;
              break;
            }
          }
        }
        if (srces.length > 1) {
          width = source.getAttribute("sizes") || "";
          width = regPxLength.test(width) && parseInt(width, 10) || lazySizes.gW(elem, elem.parentNode);
          srces.d = getX(elem);
          if (!srces.src || !srces.w || srces.w < width) {
            srces.w = width;
            src = reduceCandidate(srces.sort(ascendingSort));
            srces.src = src;
          } else {
            src = srces.src;
          }
        } else {
          src = srces[0];
        }
        return src;
      };
      var p = function(elem) {
        if (supportSrcset && elem.parentNode && elem.parentNode.nodeName.toUpperCase() != "PICTURE") {
          return;
        }
        var candidate = getCandidate(elem);
        if (candidate && candidate.u && elem._lazypolyfill.cur != candidate.u) {
          elem._lazypolyfill.cur = candidate.u;
          candidate.cached = true;
          elem.setAttribute(lazySizesCfg.srcAttr, candidate.u);
          elem.setAttribute("src", candidate.u);
        }
      };
      p.parse = parseWsrcset;
      return p;
    }();
    if (lazySizesCfg.loadedClass && lazySizesCfg.loadingClass) {
      (function() {
        var sels = [];
        ['img[sizes$="px"][srcset].', "picture > img:not([srcset])."].forEach(function(sel) {
          sels.push(sel + lazySizesCfg.loadedClass);
          sels.push(sel + lazySizesCfg.loadingClass);
        });
        lazySizesCfg.pf({
          elements: document2.querySelectorAll(sels.join(", "))
        });
      })();
    }
  });
})(ls_respimg);
var ls_attrchange = { exports: {} };
(function(module) {
  (function(window2, factory) {
    if (!window2) {
      return;
    }
    var globalInstall = function() {
      factory(window2.lazySizes);
      window2.removeEventListener("lazyunveilread", globalInstall, true);
    };
    factory = factory.bind(null, window2, window2.document);
    if (module.exports) {
      factory(requireLazysizes());
    } else if (window2.lazySizes) {
      globalInstall();
    } else {
      window2.addEventListener("lazyunveilread", globalInstall, true);
    }
  })(typeof window != "undefined" ? window : 0, function(window2, document2, lazySizes) {
    var addObserver = function() {
      var connect, disconnect, observer2, connected;
      var lsCfg = lazySizes.cfg;
      var attributes = { "data-bgset": 1, "data-include": 1, "data-poster": 1, "data-bg": 1, "data-script": 1 };
      var regClassTest = "(\\s|^)(" + lsCfg.loadedClass;
      var docElem = document2.documentElement;
      var setClass = function(target) {
        lazySizes.rAF(function() {
          lazySizes.rC(target, lsCfg.loadedClass);
          if (lsCfg.unloadedClass) {
            lazySizes.rC(target, lsCfg.unloadedClass);
          }
          lazySizes.aC(target, lsCfg.lazyClass);
          if (target.style.display == "none" || target.parentNode && target.parentNode.style.display == "none") {
            setTimeout(function() {
              lazySizes.loader.unveil(target);
            }, 0);
          }
        });
      };
      var onMutation = function(mutations) {
        var i, len, mutation, target;
        for (i = 0, len = mutations.length; i < len; i++) {
          mutation = mutations[i];
          target = mutation.target;
          if (!target.getAttribute(mutation.attributeName)) {
            continue;
          }
          if (target.localName == "source" && target.parentNode) {
            target = target.parentNode.querySelector("img");
          }
          if (target && regClassTest.test(target.className)) {
            setClass(target);
          }
        }
      };
      if (lsCfg.unloadedClass) {
        regClassTest += "|" + lsCfg.unloadedClass;
      }
      regClassTest += "|" + lsCfg.loadingClass + ")(\\s|$)";
      regClassTest = new RegExp(regClassTest);
      attributes[lsCfg.srcAttr] = 1;
      attributes[lsCfg.srcsetAttr] = 1;
      if (window2.MutationObserver) {
        observer2 = new MutationObserver(onMutation);
        connect = function() {
          if (!connected) {
            connected = true;
            observer2.observe(docElem, { subtree: true, attributes: true, attributeFilter: Object.keys(attributes) });
          }
        };
        disconnect = function() {
          if (connected) {
            connected = false;
            observer2.disconnect();
          }
        };
      } else {
        docElem.addEventListener("DOMAttrModified", /* @__PURE__ */ function() {
          var runs;
          var modifications = [];
          var callMutations = function() {
            onMutation(modifications);
            modifications = [];
            runs = false;
          };
          return function(e) {
            if (connected && attributes[e.attrName] && e.newValue) {
              modifications.push({ target: e.target, attributeName: e.attrName });
              if (!runs) {
                setTimeout(callMutations);
                runs = true;
              }
            }
          };
        }(), true);
        connect = function() {
          connected = true;
        };
        disconnect = function() {
          connected = false;
        };
      }
      addEventListener("lazybeforeunveil", disconnect, true);
      addEventListener("lazybeforeunveil", connect);
      addEventListener("lazybeforesizes", disconnect, true);
      addEventListener("lazybeforesizes", connect);
      connect();
      removeEventListener("lazybeforeunveil", addObserver);
    };
    addEventListener("lazybeforeunveil", addObserver);
  });
})(ls_attrchange);
